import { Component, ViewChild, Inject, LOCALE_ID, OnInit, OnDestroy } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { GlobalApp } from "../../tools/global";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import {
  AdminInteractiveService,
  AdminInteractiveSubService,
  SubPeriodTypesService,
  SubHeadersService,
  InteractSubTypesService,
  UnpaidOrdersService,
  SubscriptionUsersService,
  AdminCouponsService,
  AdminCouponsLevelsService,
  AdminUsersService,
  AdminXmlaSubscriptionService,
  InteractivesService,
  SubscriptionService,
  SettingsService,
  PartnerEmbedService,
  SubscriptionStatisticsService,
  PreFilterService,
  AlertsService,
  ReportExportService, DataOnDemandService,
} from "../../api/services";
import {
  Interacts,
  InteractSubTypes,
  InteractSubType,
  InteractSubLevel,
  InteractSubPrice,
  SubPeriodTypes,
  SubHeaders,
  SubscriptionHeader,
  UnpaidOrderViewModel,
  SubscriptionUserListViewModel,
  Coupons,
  Users,
  UserViewModel,
  XmlaSubscriptionTypeEx,
  XmlaSubscriptionLevelEx,
  XmlaSubscriptionPriceEx,
  EditInteractSubscription,
  InteractSubLevels,
  ModifiedInteract,
  UdModInteractives,
  InteractReportExportStatus,
  InteractReportsEx,
  SubscriptionUserListUserViewModel,
  UserTypes,
  SubUsers,
  UpdateUserSubscriptionRequest,
  PartnerEmbed,
  PartnerEmbedAdminDetails,
  PartnerEmbedDetails,
  SubscriptionAnalytics,
  UserAnalytics,
  UserInteractiveAnalytics,
  AlertModel, DodEndPoint, FilterType, ApiEndPoint,
} from '../../api/models';
import {
  EditInteractiveDialogData,
  EditInteractiveDialogComponent,
} from "../../dialogs/admin/edit-interactive-dialog/edit-interactive-dialog.component";
import { DialogResultType, DialogResult } from "../../dialogs/DialogResult";
import {
  EditSubLevelsDialogData,
  EditSubLevelsDialogComponent,
} from "../../dialogs/admin/edit-subscription-level-dialog/edit-subscription-level-dialog.component";
import {
  EditSubPricesDialogComponent,
  EditSubPricesDialogData,
} from "../../dialogs/admin/edit-subscription-price-dialog/edit-subscription-price-dialog.component";
import {
  EditInteractiveSubscriptionsDialogComponent,
  EditInteractiveSubscriptionsDialogData,
} from "../../dialogs/admin/edit-interactive-subscription-dialog/edit-interactive-subscription-dialog.component";
import {
  EditCouponLevelsDialogComponent,
  EditCouponLevelsDialogData,
} from "../../dialogs/admin/edit-coupon-levels-dialog/edit-coupon-levels-dialog.component";
import {
  EditSubscriptionDialogData,
  EditSubscriptionDialogComponent,
} from "../../dialogs/admin/edit-subscription-dialog/edit-subscription-dialog.component";
import {
  EditUnpaidOrderDialogData,
  EditUnpaidOrderDialogComponent,
} from "../../dialogs/admin/edit-unpaid-order-dialog/edit-unpaid-order-dialog.component";
import {
  EditXmlaSubscriptionsDialogData,
  EditXmlaSubscriptionsDialogComponent,
} from "../../dialogs/admin/edit-xmla-subscription-dialog/edit-xmla-subscription-dialog.component";
import {
  EditXmlaSubscriptionLevelsDialogData,
  EditXmlaSubscriptionLevelsDialogComponent,
} from "../../dialogs/admin/edit-xmla-subscription-level-dialog/edit-xmla-subscription-level-dialog.component";
import {
  EditXmlaSubscriptionPricesDialogData,
  EditXmlaSubscriptionPricesDialogComponent,
} from "../../dialogs/admin/edit-xmla-subscription-price-dialog/edit-xmla-subscription-price-dialog.component";
import {
  EditCouponsDialogData,
  EditCouponsDialogComponent,
} from "../../dialogs/admin/edit-coupon-dialog/edit-coupon-dialog.component";
import { MessageDialogComponent } from "../../dialogs/message-dialog/message-dialog.component";
import { AdminModifiedInteractiveService } from "../../api/services/admin-modified-interactive.service";
import { ModifiedInteractiveDetails } from "../../api/models/modified-interactive-details";
import {
  SimpleGridComponent,
  AddDef,
  ColumnDef,
  EditDef,
} from "../../elements/simple-grid/simple-grid.component";
import {
  EditUserDialogData,
  EditUserDialogComponent,
} from "../../dialogs/admin/edit-user-dialog/edit-user-dialog.component";
import { AgGridAngular } from "ag-grid-angular";
import { Clipboard } from "@angular/cdk/clipboard";
import { formatDate, formatCurrency } from "@angular/common";
import {
  EditInteractReportsDialogData,
  EditInteractReportsDialogComponent,
} from "../../dialogs/admin/edit-interactive-report-dialog/edit-interactive-report-dialog.component";
import { ConfirmDialogComponent } from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { Observable, ReplaySubject, Subject } from "rxjs";
import {FormControl, UntypedFormControl} from '@angular/forms';
import { map, startWith, takeUntil } from "rxjs/operators";
import {PowerbiEmbedComponent} from "../../elements/powerbi-embed/powerbi-embed.component";
import {AddSubscriptionUserDialogComponent} from "../../dialogs/add-subscription-user-dialog/add-subscription-user-dialog.component";
import {
  EditPartnerEmbedData,
  EditPartnerEmbedDialogComponent
} from "../../dialogs/admin/edit-partner-embed-dialog/edit-partner-embed-dialog.component";
import { UsageAnalytics } from "../../api/models/usage-analytics";

@Component({
  selector: "admin",
  templateUrl: "./admin.component.html",
})
export class AdminComponent implements OnInit, OnDestroy {
  @ViewChild(PowerbiEmbedComponent) powerBi;
  showPowerBi: boolean = false;

  selectedAsUser: SubUsers = null;

  loadingInteractiveData: boolean;
  allInteractives: Interacts[];
  @ViewChild("interactiveDataGrid") interactiveDataGrid: AgGridAngular;

  loadingDeletedInteractiveData: boolean;
  allDeletedInteractives: Interacts[];
  @ViewChild("deletedInteractiveDataGrid") deletedInteractiveDataGrid: AgGridAngular;

  interactiveColumnDefs = [
    {
      headerName: "ID",
      field: "interactId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Name",
      field: "interactName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Modify",
      field: "canModify",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "PF Company",
      field: "preFilterCompanyAvailable",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "PF Title",
      field: "preFilterTitleAvailable",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "PF Region",
      field: "preFilterRegionAvailable",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "PF Industry",
      field: "preFilterIndustryAvailable",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "PF Occupation",
      field: "preFilterOccupationAvailable",
      sortable: true,
      filter: true,
      resizable: true,
    }
  ];

  loadingInteractiveReportData: boolean;
  allInteractiveReports: InteractReportsEx[];
  @ViewChild("interactiveReportDataGrid")
  interactiveReportDataGrid: AgGridAngular;
  interactiveReportColumnDefs = [
    {
      headerName: "ID",
      field: "interactReportId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Interactive",
      field: "interactName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Prefix",
      field: "powerBIPrefix",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Display Rank",
      field: "displayRank",
      sortable: true,
      filter: true,
      resizable: true,
    }
  ];

  loadingInteractiveSubscriptionData: boolean;
  allInteractiveSubscriptions: InteractSubType[];
  @ViewChild("interactiveSubscriptionDataGrid")
  interactiveSubscriptionDataGrid: AgGridAngular;

  loadingDeletedInteractiveSubscriptionData: boolean;
  allDeletedInteractiveSubscriptions: InteractSubType[];
  @ViewChild("deletedInteractiveSubscriptionDataGrid")
  deletedInteractiveSubscriptionDataGrid: AgGridAngular;

  interactiveSubscriptionColumnDefs = [
    {
      headerName: "ID",
      field: "interactSubTypeId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Name",
      field: "interactSubTypeName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Purchase URL",
      field: "purchaseUrl",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingInteractiveSubscriptionLevels: boolean;
  allInteractiveSubscriptionLevels: InteractSubLevel[];
  @ViewChild("interactiveSubscriptionLevelDataGrid")
  interactiveSubscriptionLevelDataGrid: AgGridAngular;
  interactiveSubscriptionLevelColumnDefs = [
    {
      headerName: "Subscription Type",
      field: "subTypeDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Level ID",
      field: "interactSubLevelId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Max Admin Users",
      field: "maxAdminUsers",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Max Design Users",
      field: "maxDesignerUsers",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Max Dashboard Users",
      field: "maxDashboardUsers",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Max Report Users",
      field: "maxReportUsers",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Download",
      field: "allowInteractiveDownload",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Purchase",
      field: "allowPurchase",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Modify",
      field: "allowModify",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Pre-Filtering",
      field: "allowPreFilter",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Invoice",
      field: "allowInvoice",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Purchase URL",
      field: "purchaseUrl",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingInteractiveSubscriptionPrices: boolean;
  allInteractiveSubscriptionPrices: InteractSubPrice[];
  @ViewChild("interactiveSubscriptionPriceDataGrid")
  interactiveSubscriptionPriceDataGrid: AgGridAngular;
  interactiveSubscriptionPriceColumnDefs = [
    {
      headerName: "Subscription Type",
      field: "subTypeDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Level",
      field: "subLevelDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Period",
      field: "periodDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Price",
      field: "price",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.currencyValueFormatter,
    },
    {
      headerName: "Purchase URL",
      field: "purchaseUrl",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingPeriodTypes: boolean;
  allPeriodTypes: SubPeriodTypes[];
  @ViewChild("subscriptionPeriodTypeDataGrid")
  subscriptionPeriodTypeDataGrid: AgGridAngular;
  subscriptionPeriodTypeColumnDefs = [
    {
      headerName: "Period Type ID",
      field: "periodTypeId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Unit Type",
      field: "unitType",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Unit Quantity",
      field: "unitQuantity",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingXmlaSubscriptionData: boolean;
  allXmlaSubscriptions: XmlaSubscriptionTypeEx[];
  @ViewChild("xmlaSubscriptionDataGrid")
  xmlaSubscriptionDataGrid: AgGridAngular;
  xmlaSubscriptionColumnDefs = [
    {
      headerName: "ID",
      field: "xmlaSubscriptionTypeId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Name",
      field: "xmlaSubscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Purchase URL",
      field: "purchaseUrl",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingXmlaSubscriptionLevels: boolean;
  allXmlaSubscriptionLevels: XmlaSubscriptionLevelEx[];
  @ViewChild("xmlaSubscriptionLevelDataGrid")
  xmlaSubscriptionLevelDataGrid: AgGridAngular;
  xmlaSubscriptionLevelColumnDefs = [
    {
      headerName: "Subscription Type",
      field: "xmlaSubscriptionTypeDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Level ID",
      field: "xmlaSubscriptionLevelId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Invoice",
      field: "allowInvoice",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Purchase URL",
      field: "purchaseUrl",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingXmlaSubscriptionPrices: boolean;
  allXmlaSubscriptionPrices: XmlaSubscriptionPriceEx[];
  @ViewChild("xmlaSubscriptionPriceDataGrid")
  xmlaSubscriptionPriceDataGrid: AgGridAngular;
  xmlaSubscriptionPriceColumnDefs = [
    {
      headerName: "Subscription Type",
      field: "subscriptionTypeDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Level",
      field: "subscriptionLevelDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Period",
      field: "periodDescription",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Price",
      field: "price",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.currencyValueFormatter,
    },
  ];

  public subscriptionSearchCtrl: FormControl = new FormControl();
  public subscriptionSearchFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public filteredSubscriptions: ReplaySubject<SubscriptionHeader[]> = new ReplaySubject<SubscriptionHeader[]>();
  currentlySelectedSubscription: SubscriptionHeader = undefined;

  loadingSubscriptions: boolean;
  allSubscriptions: SubscriptionHeader[];
  @ViewChild("subscriptionDataGrid") subscriptionDataGrid: AgGridAngular;

  loadingDeletedSubscriptions: boolean;
  allDeletedSubscriptions: SubscriptionHeader[];
  @ViewChild("deletedSubscriptionDataGrid") deletedSubscriptionDataGrid: AgGridAngular;

  subscriptionColumnDefs = [
    {
      headerName: "Subscription Name",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Organization",
      field: "organizationName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription ID",
      field: "subscriptionId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription Level",
      field: "subscriptionLevelName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription Type",
      field: "subscriptionTypeName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Created Date",
      field: "createdDate",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateValueFormatter,
    },
    {
      headerName: "Expiration Date",
      field: "expireDate",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateValueFormatter,
    },
    {
      headerName: "Auto Renew",
      field: "autoRenew",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  public filteredSubscriptionUsers: ReplaySubject<subscriptionDetailsUser[]> = new ReplaySubject<subscriptionDetailsUser[]>();
  @ViewChild('subscriptionUsersDataGrid') subscriptionUsersDataGrid: AgGridAngular;
  subscriptionUsersColumnDefs = [
    {
      headerName: "ID",
      field: "id",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "First Name",
      field: "firstName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Last Name",
      field: "lastName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Title",
      field: "title",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Email",
      field: "emailAddress",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Type",
      field: "userTypeName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Confirmed?",
      field: "confirmed",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  public filteredSubscriptionUnRegisteredUsers: ReplaySubject<subscriptionDetailsUser[]> = new ReplaySubject<subscriptionDetailsUser[]>();
  @ViewChild('subscriptionUnRegisteredUsersDataGrid') subscriptionUnRegisteredUsersDataGrid: AgGridAngular;
  subscriptionUnRegisteredUsersColumnDefs = [
    {
      headerName: "Email",
      field: "emailAddress",
      sortable: true,
      filter: true,
      resizable: true,
    }
  ];

  public filteredInteractives: ReplaySubject<Interacts[]> = new ReplaySubject<Interacts[]>();
  @ViewChild("subscriptionInteractsDataGrid") subscriptionInteractsDataGrid: AgGridAngular;
  subscriptionInteractiveColumnDefs = [
    {
      headerName: "ID",
      field: "interactId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Name",
      field: "interactName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  public filteredSubscriptionInteractives: ReplaySubject<ModifiedInteractiveDetails[]> = new ReplaySubject<ModifiedInteractiveDetails[]>();
  @ViewChild("subscriptionModifedInteractivesDataGrid")
  subscriptionModifedInteractivesDataGrid: AgGridAngular;
  subscriptionInteractivesDataGridColumnDefs = [
    {
      headerName: "Workspace Name",
      field: "powerBiArtifactName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription Name",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Modified Interactive ID",
      field: "modifiedInteractiveId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Modified Interactive Name",
      field: "modifiedInteractiveName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Created By",
      field: "createdBy",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Last Modified",
      field: "lastModifiedOn",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "File ID",
      field: "fileId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Power BI Report ID",
      field: "powerBiReportId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Power BI Dataset ID",
      field: "powerBiDatasetId",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];


  loadingUnpaidOrders: boolean;
  allUnpaidOrders: UnpaidOrderViewModel[];
  @ViewChild("unpaidOrderDataGrid") unpaidOrderDataGrid: AgGridAngular;
  unpaidOrderColumnDefs = [
    {
      headerName: "Subscription Name",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription Admins",
      cellRenderer: this.renderUnpaidOrderAdmins,
      sortable: true,
      filter: true,
      resizable: true,
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: "Total Due",
      field: "totalDue",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.currencyValueFormatter,
    },
    {
      headerName: "Total Paid",
      field: "totalPaid",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.currencyValueFormatter,
    },
    {
      headerName: "Paid Date",
      field: "paidDate",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateValueFormatter,
    },
  ];

  loadingSubscriptionUsers: boolean;
  allSubscriptionUsers: SubscriptionUserListViewModel[];
  @ViewChild("subscriptionuserDataGrid")
  subscriptionuserDataGrid: AgGridAngular;
  subscriptionuserColumnDefs = [
    {
      headerName: "Subscription Name",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription ID",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription Type Description",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Purchase Date",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Expiration Date",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "User Count / Max",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Users",
      cellRenderer: this.renderSubscriptionUsers,
      sortable: true,
      filter: true,
      resizable: true,
      wrapText: true,
      autoHeight: true,
    },
  ];

  loadingCoupons: boolean;
  allCoupons: Coupons[];
  @ViewChild("couponcodeDataGrid") couponcodeDataGrid: AgGridAngular;
  couponcodeColumnDefs = [
    {
      headerName: "Coupon Code",
      field: "couponCode",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Start Date",
      field: "startDate",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateValueFormatter,
    },
    {
      headerName: "End Date",
      field: "endDate",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateValueFormatter,
    },
    {
      headerName: "One Time Use",
      field: "oneTimeUse",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Coupon Type",
      field: "couponType",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Free Trial Period Type",
      field: "freeTrialPeriodType",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Discount Percent",
      field: "discountPercent",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Discount Amount",
      field: "discountAmount",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Active",
      field: "active",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingUsers: boolean;
  allUsers: UserViewModel[];
  @ViewChild("userDataGrid") userDataGrid: AgGridAngular;
  userColumnDefs = [
    {
      headerName: "User ID",
      field: "userId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Last Name",
      field: "lastName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "First Name",
      field: "firstName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Email",
      field: "userName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Confirmed",
      field: "emailConfirmed",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Title",
      field: "title",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Company",
      field: "company",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Created",
      field: "createdTimeStamp",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateValueFormatter,
    },
    {
      headerName: "Modified",
      field: "modifiedTimeStamp",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateValueFormatter,
    },
  ];

  loadingModifiedInteractives: boolean;
  allModifiedInteractives: ModifiedInteractiveDetails[];
  @ViewChild("modifiedinteractiveDataGrid")
  modifiedinteractiveDataGrid: AgGridAngular;
  modifiedinteractiveColumnDefs = [
    {
      headerName: "Workspace Name",
      field: "powerBiArtifactName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription ID",
      field: "subscriptionId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Subscription Name",
      field: "subscriptionName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Modified Interactive ID",
      field: "modifiedInteractiveId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Modified Interactive Name",
      field: "modifiedInteractiveName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Created By",
      field: "createdBy",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Last Modified",
      field: "lastModifiedOn",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "File ID",
      field: "fileId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Power BI Report ID",
      field: "powerBiReportId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Power BI Dataset ID",
      field: "powerBiDatasetId",
      sortable: true,
      filter: true,
      resizable: true,
    },
  ];

  loadingPartnerEmbeds: boolean;
  allPartnerEmbeds: PartnerEmbedAdminDetails[];
  @ViewChild("partnerEmbedDataGrid")
  partnerEmbedDataGrid: AgGridAngular;
  partnerEmbedColumnDefs = [
    {
      headerName: "Partner Name",
      field: "name",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Interactive",
      field: "interactiveName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Embed Key",
      field: "partnerEmbedKey",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Enabled?",
      field: "enabled",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Allow Remote Filtering?",
      field: "allowRemoteFiltering",
      sortable: true,
      filter: true,
      resizable: true,
    }
  ];

  public baseSubscriptionStats: SubscriptionAnalytics = undefined;
  @ViewChild("subscriptionStatsUserDataGrid")
  subscriptionStatsUserDataGrid: AgGridAngular;
  subscriptionStatsUserDataGridColumnDefs = [
    {
      headerName: "User",
      field: "lastLogin.userName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Email",
      field: "lastLogin.email",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Last Login",
      field: "lastLogin.lastLogin",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateTimeValueFormatter,
    }
    ,
    {
      headerName: "Report Export Count",
      field: "reportExportCount",
      sortable: true,
      filter: true,
      resizable: true,
    }
  ];

  public userInteractiveStats: UserInteractiveAnalytics[] = undefined;
  @ViewChild("userInteractiveStatsDataGrid")
  userInteractiveStatsDataGrid: AgGridAngular;

  public interactiveStats: UserInteractiveAnalytics[] = undefined;
  @ViewChild("interactiveStatsDataGrid")
  interactiveStatsDataGrid: AgGridAngular;

  interactiveStatDetailsColumnDef = [
    {
      headerName: "ID",
      field: "interactiveId",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Name",
      field: "interactiveName",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Average Time",
      field: "averageTime",
      sortable: true,
      filter: true,
      resizable: true,
    }
  ];

  public interactiveBookmarkStats: UsageAnalytics[] = undefined;
  @ViewChild("interactiveBookmarkStatsDataGrid")
  interactiveBookmarkStatsDataGrid: AgGridAngular;

  public interactiveFilterStats: UsageAnalytics[] = undefined;
  @ViewChild("interactiveFilterStatsDataGrid")
  interactiveFilterStatsDataGrid: AgGridAngular;

  usageAnalyticsColumnDef = [
    {
      headerName: "Name",
      field: "name",
      sortable: true,
      filter: true,
      resizable: true,
    },
    {
      headerName: "Last Used",
      field: "lastUsed",
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: this.dateTimeValueFormatter,
    },
  ];

  public alertMessages: AlertModel[] = [];
  public newAlertMessage: AlertModel = {
    id: 0,
    active: false,
    message: ''
  };

  public allDataOnDemandEndPoints: DodEndPoint[] = [];
  public allApiEndPoints: ApiEndPoint[] = [];

  protected _onDestroy = new Subject<void>();

  public isAdmin: boolean = false;
  public isSupportAdmin: boolean = false;

  public enableSideNavigation: boolean = false;

  public filterTypes: FilterType[] = [];

  constructor(
    private app: GlobalApp,
    private snackBar: MatSnackBar,
    private router: Router,
    private globalApp: GlobalApp,
    private http: HttpClient,
    private dialog: MatDialog,
    private clipboard: Clipboard,
    private adminInteractiveService: AdminInteractiveService,
    private adminInteractiveSubService: AdminInteractiveSubService,
    private subPeriodTypesService: SubPeriodTypesService,
    private subHeadersService: SubHeadersService,
    private subscriptionUsersService: SubscriptionUsersService,
    private adminCouponsService: AdminCouponsService,
    private adminCouponLevelssService: AdminCouponsLevelsService,
    private interactiveService: InteractivesService,
    private unpaidOrdersService: UnpaidOrdersService,
    private adminUserService: AdminUsersService,
    private adminXmlaSubscriptionService: AdminXmlaSubscriptionService,
    private adminModifiedInteractiveService: AdminModifiedInteractiveService,
    private adminPartnerEmbedService: PartnerEmbedService,
    private subscriptionService: SubscriptionService,
    private settingsService: SettingsService,
    private subscriptionStatisticsService: SubscriptionStatisticsService,
    private preFilterService: PreFilterService,
    private alertsService: AlertsService,
    private reportExportService: ReportExportService,
    private dodService: DataOnDemandService
  ) {
    this.loadingInteractiveData = true;
    this.loadingInteractiveReportData = true;
    this.loadingInteractiveSubscriptionData = true;
    this.loadingDeletedInteractiveSubscriptionData = true;
    this.loadingInteractiveSubscriptionLevels = true;
    this.loadingInteractiveSubscriptionPrices = true;
    this.loadingPeriodTypes = true;
    this.loadingXmlaSubscriptionData = true;
    this.loadingXmlaSubscriptionLevels = true;
    this.loadingXmlaSubscriptionPrices = true;

    this.loadingSubscriptions = true;
    this.loadingDeletedSubscriptions = true;
    this.loadingUnpaidOrders = true;
    this.loadingSubscriptionUsers = true;
    this.loadingCoupons = true;
    this.loadingUnpaidOrders = true;
    this.loadingUsers = true;
    this.loadingModifiedInteractives = true;

    this.loadingPartnerEmbeds = true;

    this.allInteractives = [];
    this.allInteractiveReports = [];
    this.allInteractiveSubscriptions = [];
    this.allDeletedInteractiveSubscriptions = [];
    this.allDataOnDemandEndPoints = [];
    this.allApiEndPoints = [];
    this.allInteractiveSubscriptionLevels = [];
    this.allInteractiveSubscriptionPrices = [];
    this.allPeriodTypes = [];
    this.allXmlaSubscriptions = [];
    this.allXmlaSubscriptionLevels = [];
    this.allXmlaSubscriptionPrices = [];
    this.allSubscriptions = [];
    this.allSubscriptionUsers = [];
    this.allCoupons = [];
    this.allUnpaidOrders = [];
    this.allUsers = [];
    this.allModifiedInteractives = [];
    this.allPartnerEmbeds = [];

    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      } else {
        if (!result.isAdmin && !result.isSupportAdmin) {
          this.router.navigate(["/"]);
        } else {

          this.isAdmin = result.isAdmin;
          this.isSupportAdmin = result.isSupportAdmin;

          this.loadInteractives();
          this.loadInteractiveReports();
          this.loadInteractiveSubscriptions();
          this.loadInteractiveSubscriptionLevels();
          this.loadInteractiveSubscriptionPrices();
          this.loadPeriodTypes();
          this.loadXmlaSubscriptions();
          this.loadXmlaSubscriptionLevels();
          this.loadXmlaSubscriptionPrices();
          this.loadSubscriptions();
          this.loadUnpaidOrders();
          this.loadSubscriptionUsers();
          this.loadCoupons();
          this.loadUsers();
          this.loadModifiedInteractives();
          this.loadPartnerEmbeds();
          this.loadAlerts();

          this.dodService.dataOnDemandGetAllDodFilterTypes().subscribe(results => {
            this.filterTypes = results;
          });
        }
      }
    });
  }

  ngOnInit() {

    this.subscriptionSearchCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((selection) => {
        this.setSelectedSubscription(selection);
      });

    /*this.filteredSubscriptions = this.subscriptionSearchCtrl.valueChanges.pipe(
      //takeUntil(this._onDestroy),
      map((value : any) => {
        if (typeof value === 'string') {
          return this.newFilterSubscriptions(value);
        } else {
          return this.newFilterSubscriptions(value.subscriptionName + ' [' + value.organizationName + ']');
        }
      })
    )*/

    this.subscriptionSearchCtrl.valueChanges.pipe(
      takeUntil(this._onDestroy)
    ).subscribe((value) => {
      const t = value;
    });

    this.loadGlobalSettigns();
  }

  protected setSubscriptionSearchValue(subHeader: SubscriptionHeader) : string {
    if (!subHeader) return '';
    return subHeader.subscriptionName + ' [' + subHeader.organizationName + ']';
  }

  private lastSearch: string = '';

  searchTextChanged($event: Event) {
    let search = undefined;
    if ($event?.currentTarget)
    {
      if (($event.currentTarget as any).value) {
        search = ($event.currentTarget as any).value;
      }
    }

    this.lastSearch = search;
    this.filteredSubscriptions.next(this.newFilterSubscriptions(search));
  }

  protected newFilterSubscriptions(inputSearch: string) : SubscriptionHeader[] {
    if (!this.allSubscriptions) return [];
    if (!inputSearch || inputSearch === '') return this.allSubscriptions;

    const search = inputSearch.toLowerCase();

    const userMatches = this.allSubscriptionUsers.filter(x => {
        return x.users.filter(y => {
          return y.name.toLowerCase().indexOf(search) > -1 || y.emailAddress.toLowerCase().indexOf(search) > -1;
        }).length > 0;
      }
    );

    const subscriptionMatches = this.allSubscriptions.filter(x => {
      return x.organizationName.toLowerCase().indexOf(search) > -1 || x.subscriptionName.toLowerCase().indexOf(search) > -1
    });

    const subscriptionIds = userMatches.map(x => x.subscriptionId);
    subscriptionIds.push(... subscriptionMatches.map(x => x.subscriptionId));

    return this.allSubscriptions.filter(subscription => subscriptionIds.includes(subscription.subscriptionId));
  }

  protected filterSubscriptions() {
    if (!this.allSubscriptions) {
      return;
    }

    let search = this.subscriptionSearchCtrl.value;

    if (!search) {
      //this.filteredSubscriptions.next(this.allSubscriptions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    const subscriptionIds = this.allSubscriptionUsers.filter(x => x.users.filter(y => y.name.toLowerCase().includes(search) || y.emailAddress.toLowerCase().includes(search)).length > 0).map(x => x.subscriptionId);
    subscriptionIds.concat(this.allSubscriptions.filter(x => x.subscriptionName.toLowerCase().includes(search) || x.organizationName.toLowerCase().includes(search)).map(x => x.subscriptionId));

    /*this.filteredSubscriptions.next(
      this.allSubscriptions.filter(subscription => subscriptionIds.includes(subscription.subscriptionId))
    );*/
  }

  setSelectedSubscription(subscription: SubscriptionHeader) {

    this.currentlySelectedSubscription = subscription;
    this.filterSelectedSubscriptionUsers();
    this.filterSelectedSubscriptionInteractives();
    this.loadBaseStats(subscription);
  }

  loadBaseStats(subscription: SubscriptionHeader) {
    this.subscriptionStatisticsService.subscriptionStatisticsGetBaseSubscriptionStatistics(subscription.subscriptionId).subscribe(result => {
      this.baseSubscriptionStats = result;
      this.interactiveStats = result.interactives;
    })
  }

  userAnalyticsRowSelected() {
    const selectedNodes = this.subscriptionStatsUserDataGrid.api.getSelectedRows();
    const userAnalytics: UserAnalytics = selectedNodes[0];
    this.userInteractiveStats = userAnalytics.interactiveMetrics;
  }

  interactiveAnalyticsRowSelected() {
    const selectedNodes = this.userInteractiveStatsDataGrid.api.getSelectedRows();
    const interactiveAnalytics: UserInteractiveAnalytics = selectedNodes[0];
    this.interactiveBookmarkStats = interactiveAnalytics.bookmarkUsage;
    this.interactiveFilterStats = interactiveAnalytics.filterUsage;
  }

  filterSelectedSubscriptionUsers() {
    if(this.currentlySelectedSubscription) {
      const activeUsers = this.allSubscriptionUsers.find(x => x.subscriptionId === this.currentlySelectedSubscription.subscriptionId)?.users.map(x => {
        const user = this.allUsers.find(u => u.userId == x.id);
        return {
          ...x,
          ...user,
          invoiceManager: x.invoiceManager,
          userManager: x.userManager
        } as subscriptionDetailsUser;
      })

      this.filteredSubscriptionUsers.next(activeUsers);

      const unregisteredUsers = this.allSubscriptionUsers.find(x => x.subscriptionId === this.currentlySelectedSubscription.subscriptionId).unRegisteredUsers.map(x => {
        return {
          ...x
        } as subscriptionDetailsUser;
      });

      this.filteredSubscriptionUnRegisteredUsers.next(unregisteredUsers);
    }
  }

  filterSelectedSubscriptionInteractives() {
    // this.filteredInteractives.next(this.allInteractives.filter(x => this.currentlySelectedSubscription.))
    this.interactiveService.interactivesGetInteractivesList2(this.currentlySelectedSubscription.subscriptionId).subscribe(x => {
      this.filteredInteractives.next(x);
    });
    this.filteredSubscriptionInteractives.next(this.allModifiedInteractives.filter(x => x.subscriptionId == this.currentlySelectedSubscription.subscriptionId));
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  currencyValueFormatter(params) {
    if (params.value === null || params.value === undefined) return "";

    return formatCurrency(params.value, "en-US", "$");
  }

  dateValueFormatter(params) {
    if (params.value === null || params.value === undefined) return "";

    return formatDate(params.value, "fullDate", "en-US");
  }

  dateTimeValueFormatter(params) {
    if (params.value === null || params.value === undefined) return "";

    return formatDate(params.value, "medium", "en-US");
  }

  loadInteractives() {
    this.loadingInteractiveData = true;
    this.loadingDeletedInteractiveData = true;

    this.adminInteractiveService
      .adminInteractiveGetInteractives()
      .subscribe((result) => {
        this.allInteractives = result;
        this.loadingInteractiveData = false;
        this.interactiveDataGrid?.api?.sizeColumnsToFit();
      });

    this.adminInteractiveService
      .adminInteractiveGetDeletedInteractives()
      .subscribe((result) => {
        this.allDeletedInteractives = result;
        this.loadingDeletedInteractiveData = false;
        this.deletedInteractiveDataGrid?.api?.sizeColumnsToFit();
      })
  }

  editSelectedInteractive() {
    const selectedNodes = this.interactiveDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editInteractive(selectedData[0]);
    }

    return false;
  }

  deleteSelectedInteractive() : boolean {
    const selectedNodes = this.interactiveDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);

    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Interactive",
        "Are you sure you want to delete this interactive?  This is a soft delete and can be undone."
      ).subscribe((result) => {
        if (result.ResultType === DialogResultType.Ok) {
          this.adminInteractiveService.adminInteractiveDeleteInteractive(selectedData[0].interactId).subscribe(() => {
              this.loadInteractives();
            },
            (error) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error",
                "Error Deleting Interactive: " + error.error.message + "."
              );
            });
        }
      });
    }
    return false;
  }

  unDeleteSelectedInteractive() : boolean {
    const selectedNodes = this.deletedInteractiveDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);

    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Interactive",
        "Are you sure you want to un-delete this interactive?"
      ).subscribe((result) => {
        if (result.ResultType === DialogResultType.Ok) {
          this.adminInteractiveService.adminInteractiveUnDeleteInteractive(selectedData[0].interactId).subscribe(() => {
              this.loadInteractives();
            },
            (error) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error",
                "Error Un-Deleting Interactive: " + error.error.message + "."
              );
            });
        }
      });
    }
    return false;
  }

  /*editSelectedInteractivePreFilter() {
    const selectedNodes = this.interactiveDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editInteractiveInteractivePreFilter(selectedData[0]);
    }

    return false;
  }*/

  resizeColumnsInteractive() {
    const allColumnIds = [];
    this.interactiveDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.interactiveDataGrid.columnApi.autoSizeColumns(allColumnIds, false);

    return false;
  }

  editInteractive(targetInteract: Interacts): boolean {
    this.adminInteractiveService.adminInteractiveGetInteractivePrintOnDemandPages(targetInteract.interactId).subscribe(podResults => {
      this.adminInteractiveService.adminInteractiveGetInteractivePreFilterTypes(targetInteract.interactId).subscribe(preFilterResults => {
        const editParams: EditInteractiveDialogData = {
          dialogTitle: "Edit Interactive",
          interactive: targetInteract,
          podPages: podResults,
          interactFilterTypes: preFilterResults,
          filterTypes: this.filterTypes
        };

        const dialogRef = this.dialog.open(EditInteractiveDialogComponent, {
          disableClose: true,
          width: "750px",
          data: editParams,
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (
            result != null &&
            result.ResultType != null &&
            result.ResultType == DialogResultType.Ok
          ) {
            this.loadInteractives();
          }
        });
      });
    });
    return false;
  }

  /*editInteractiveInteractivePreFilter(targetInteractive: Interacts): boolean {
    const editParams: EditInteractivePreFiltersDialogData = {
      interactiveId: targetInteractive.interactId
    };

    const dialogRef = this.dialog.open(EditInteractivePreFiltersDialogComponent, {
      disableClose: true,
      width: "1100px",
      height: "600px",
      data: editParams,
    });

    dialogRef.afterClosed().subscribe((result) => {
    });

    return false;
  }*/

  addInteractive(): boolean {
    const editParams: EditInteractiveDialogData = {
      dialogTitle: "Create Interactive",
      interactive: {
        interactName: "<New Interactive>",
        freeInteractive: false,
        interactId: -1,
        description: "",
        fileId: "",
        fileName: "",
        freeInteractiveUrl: "",
        marketingUrl: "",
        powerBidatasetId: null,
        powerBidatasetPublishDate: null,
        powerBiobjectNames: null,
        powerBireportId: null,
        powerBireportPublishDate: null,
        productUrl: null,
        canModify: false,
        canPreFilter: false,
        isDeleted: false
      },
      podPages: [],
      filterTypes: this.filterTypes,
      interactFilterTypes: []
    };

    const dialogRef = this.dialog.open(EditInteractiveDialogComponent, {
      disableClose: true,
      width: "750px",
      data: editParams,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.loadInteractives();
        //do something
      }
    });

    return false;
  }

  loadInteractiveReports() {
    this.loadingInteractiveReportData = true;
    this.adminInteractiveService
      .adminInteractiveGetInteractiveReports()
      .subscribe((result) => {
        this.allInteractiveReports = result;
        this.loadingInteractiveReportData = false;
        this.interactiveReportDataGrid?.api?.sizeColumnsToFit();
      });
  }

  deleteSelectedInteractiveReport() {
    const selectedNodes = this.interactiveReportDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Report",
        "Are you sure you want to delete this report?  This will also delete all subscription exports created from this report for all users."
      ).subscribe((confirmResult) => {
        if (confirmResult.ResultType === DialogResultType.Ok) {
          this.adminInteractiveService
            .adminInteractiveDeleteInteractiveReport(
              selectedData[0].interactReportId
            )
            .subscribe((serviceResult) => {
              this.loadInteractiveReports();
            });
        }
      });
    }

    return false;
  }

  editSelectedInteractiveReport() {
    const selectedNodes = this.interactiveReportDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editInteractiveReport(selectedData[0]);
    }

    return false;
  }

  resizeColumnsInteractiveReport() {
    const allColumnIds = [];
    this.interactiveReportDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.interactiveReportDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  editInteractiveReport(targetInteract: InteractReportsEx): boolean {
    let editParams: EditInteractReportsDialogData = {
      dialogTitle: "Edit Interactive Report",
      isNew: false,
      description: targetInteract.description,
      interactId: targetInteract.interactId,
      interactReportId: targetInteract.interactReportId,
      interacts: this.allInteractives,
      name: targetInteract.name,
      powerBIPrefix: targetInteract.powerBIPrefix,
      displayRank: targetInteract.displayRank,
    };

    const dialogRef = this.dialog.open(EditInteractReportsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: editParams,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        editParams = result.ResultData;
        this.adminInteractiveService
          .adminInteractiveEditInteractiveReport({
            interactId: editParams.interactId,
            interactReportId: editParams.interactReportId,
            description: editParams.description,
            name: editParams.name,
            powerBIPrefix: editParams.powerBIPrefix,
            displayRank: editParams.displayRank
          })
          .subscribe((editResult) => {
            this.loadInteractiveReports();
          });
      }
    });

    return false;
  }

  addInteractiveReport(): boolean {
    let editParams: EditInteractReportsDialogData = {
      dialogTitle: "Create Interactive Report",
      isNew: true,
      description: "",
      interactId: -1,
      interactReportId: -1,
      interacts: this.allInteractives,
      name: "",
      powerBIPrefix: "",
      displayRank: undefined
    };

    const dialogRef = this.dialog.open(EditInteractReportsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: editParams,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        editParams = result.ResultData;
        this.adminInteractiveService
          .adminInteractiveEditInteractiveReport({
            interactId: editParams.interactId,
            interactReportId: editParams.interactReportId,
            description: editParams.description,
            name: editParams.name,
            powerBIPrefix: editParams.powerBIPrefix,
            displayRank: editParams.displayRank
          })
          .subscribe((editResult) => {
            this.loadInteractiveReports();
          });
      }
    });

    return false;
  }

  loadInteractiveSubscriptions() {
    this.loadingInteractiveSubscriptionData = true;
    this.adminInteractiveSubService
      .adminInteractiveSubGetInteractSubTypes()
      .subscribe((result) => {
        this.allInteractiveSubscriptions = result;
        this.interactiveSubscriptionDataGrid?.api?.sizeColumnsToFit();

        this.adminInteractiveSubService
          .adminInteractiveSubGetInteractSubTypeDodEndPointsAll()
          .subscribe((result2) => {
            this.allDataOnDemandEndPoints = result2;

            this.adminInteractiveSubService
              .adminInteractiveSubGetInteractSubTypeApiEndPointsAll()
              .subscribe((result3) => {
                this.allApiEndPoints = result3;

                this.loadingInteractiveSubscriptionData = false;
              });
          });
      });

    this.loadingDeletedInteractiveSubscriptionData = true;
    this.adminInteractiveSubService
      .adminInteractiveSubGetDeletedInteractSubTypes()
      .subscribe((result) => {
        this.allDeletedInteractiveSubscriptions = result;
        this.loadingDeletedInteractiveSubscriptionData = false;
        this.deletedInteractiveSubscriptionDataGrid?.api?.sizeColumnsToFit();
      });
  }

  editSelectedInteractiveSubscription() {
    const selectedNodes = this.interactiveSubscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editInteractiveSubscription(selectedData[0]);
    }

    return false;
  }

  copySelectedInteractiveSubscriptionPurchaseUrl() {
    const selectedNodes = this.interactiveSubscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.clipboard.copy(selectedData[0].purchaseUrl);
      MessageDialogComponent.showDialog(
        this.dialog,
        "Success",
        "'" + selectedData[0].purchaseUrl + "' copied to clipboard."
      );
    }

    return false;
  }

  deleteSelectedInteractiveSubscription() {
    const selectedNodes = this.interactiveSubscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Subscription Type",
        "Are you sure you want to delete this subscription type?  This is a soft delete and can be undone."
      ).subscribe((result) => {
        if (result.ResultType === DialogResultType.Ok) {
          this.adminInteractiveSubService.adminInteractiveSubDeleteInteractiveSubType(selectedData[0].interactSubTypeId).subscribe(() => {
              this.loadInteractiveSubscriptions();
              this.loadInteractiveSubscriptionLevels();
              this.loadInteractiveSubscriptionPrices();
            },
            (error) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error",
                "Error Deleting Subscription Type: " + error.error.message + "."
              );
            });
        }
      });
    }

    return false;
  }

  unDeleteSelectedInteractiveSubscription() {
    const selectedNodes = this.deletedInteractiveSubscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Subscription Type",
        "Are you sure you want to un-delete this subscription type?"
      ).subscribe((result) => {
        if (result.ResultType === DialogResultType.Ok) {
          this.adminInteractiveSubService.adminInteractiveSubUnDeleteInteractiveSubType(selectedData[0].interactSubTypeId).subscribe(() => {
              this.loadInteractiveSubscriptions();
              this.loadInteractiveSubscriptionLevels();
              this.loadInteractiveSubscriptionPrices();
            },
            (error) => {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error",
                "Error Un-Deleting Subscription Type: " + error.error.message + "."
              );
            });
        }
      });
    }

    return false;
  }

  resizeColumnsInteractiveSubscription() {
    const allColumnIds = [];
    this.interactiveSubscriptionDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.interactiveSubscriptionDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  resizeColumnsDeletedInteractiveSubscription() {
    const allColumnIds = [];
    this.deletedInteractiveSubscriptionDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.deletedInteractiveSubscriptionDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  editInteractiveSubscription(
    targetInteractiveSubscription: InteractSubType
  ): boolean {
    let params: EditInteractiveSubscriptionsDialogData = {
      isNew: false,
      interactSubTypeId: targetInteractiveSubscription.interactSubTypeId,
      description: targetInteractiveSubscription.description,
      dialogTitle: "Edit Interactive Subscription",
      interactives: this.allInteractives,
      endPoints: this.allDataOnDemandEndPoints,
      apiEndPoints: this.allApiEndPoints,
      appliedInteractives: [],
      appliedEndPoints: [],
      appliedApiEndPoints: [],
      appliedLicenses: [],
      interactSubTypeName: targetInteractiveSubscription.interactSubTypeName,
      marketingUrl: targetInteractiveSubscription.marketingUrl,
      restrictPurchaseEmails: [],
      adminInteractiveSubService: this.adminInteractiveSubService,
      licenseText: targetInteractiveSubscription.licenseHtml,
    };

    const dialogRef = this.dialog.open(
      EditInteractiveSubscriptionsDialogComponent,
      {
        disableClose: true,
        width: "500px",
        data: params,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const editData: EditInteractSubscription = {
          interactSubTypeId: params.interactSubTypeId,
          emailAddresses: params.restrictPurchaseEmails.join(","),
          description: params.description,
          interactIds: "",
          dodEndPointIds: "",
          apiEndPointIds: "",
          licenseHtml: params.licenseText,
          marketingUrl: params.marketingUrl,
          name: params.interactSubTypeName,
        };

        for (let i = 0; i < params.appliedInteractives.length; i++) {
          if (editData.interactIds !== "") {
            editData.interactIds += ",";
          }
          editData.interactIds += params.appliedInteractives[
            i
          ].interactId.toString();
        }

        for (let i = 0; i < params.appliedEndPoints.length; i++) {
          if (editData.dodEndPointIds !== "") {
            editData.dodEndPointIds += ",";
          }
          editData.dodEndPointIds += params.appliedEndPoints[
            i
            ].dodEndPointId.toString();
        }

        for (let i = 0; i < params.appliedApiEndPoints.length; i++) {
          if (editData.apiEndPointIds !== "") {
            editData.apiEndPointIds += ",";
          }
          editData.apiEndPointIds += params.appliedApiEndPoints[
            i
            ].apiEndPointId.toString();
        }

        this.adminInteractiveSubService
          .adminInteractiveSubEditInteractiveSubType(editData)
          .subscribe((result) => {
            this.loadInteractiveSubscriptions();
          });
      }
    });

    return false;
  }

  addInteractiveSubscription(): boolean {
    let params: EditInteractiveSubscriptionsDialogData = {
      isNew: true,
      interactSubTypeId: -1,
      description: "",
      dialogTitle: "Create Interactive Subscription",
      interactives: this.allInteractives,
      endPoints: this.allDataOnDemandEndPoints,
      apiEndPoints: this.allApiEndPoints,
      appliedInteractives: [],
      appliedEndPoints: [],
      appliedApiEndPoints: [],
      appliedLicenses: [],
      interactSubTypeName: "",
      marketingUrl: "",
      restrictPurchaseEmails: [],
      adminInteractiveSubService: this.adminInteractiveSubService,
      licenseText: "",
    };

    const dialogRef = this.dialog.open(
      EditInteractiveSubscriptionsDialogComponent,
      {
        disableClose: true,
        width: "500px",
        data: params,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const newData: EditInteractSubscription = {
          interactSubTypeId: -1,
          emailAddresses: params.restrictPurchaseEmails.join(","),
          description: params.description,
          interactIds: "",
          dodEndPointIds: "",
          apiEndPointIds: "",
          licenseHtml: params.licenseText,
          marketingUrl: params.marketingUrl,
          name: params.interactSubTypeName,
        };

        for (var i = 0; i < params.appliedInteractives.length; i++) {
          if (newData.interactIds !== "") {
            newData.interactIds += ",";
          }
          newData.interactIds += params.appliedInteractives[
            i
          ].interactId.toString();
        }

        for (let i = 0; i < params.appliedEndPoints.length; i++) {
          if (newData.dodEndPointIds !== "") {
            newData.dodEndPointIds += ",";
          }
          newData.dodEndPointIds += params.appliedEndPoints[
            i
            ].dodEndPointId.toString();
        }

        for (let i = 0; i < params.appliedApiEndPoints.length; i++) {
          if (newData.apiEndPointIds !== "") {
            newData.apiEndPointIds += ",";
          }
          newData.apiEndPointIds += params.appliedApiEndPoints[
            i
            ].apiEndPointId.toString();
        }

        this.adminInteractiveSubService
          .adminInteractiveSubCreateInteractiveSubType(newData)
          .subscribe((result) => {
            this.loadInteractiveSubscriptions();
          });
      }
    });

    return false;
  }

  loadInteractiveSubscriptionLevels() {
    this.loadingInteractiveSubscriptionLevels = true;
    this.adminInteractiveSubService
      .adminInteractiveSubGetSubscriptionLevels()
      .subscribe((result) => {
        this.allInteractiveSubscriptionLevels = result;
        this.loadingInteractiveSubscriptionLevels = false;
        this.interactiveSubscriptionLevelDataGrid?.api?.sizeColumnsToFit();
      });
  }

  editSelectedInteractiveSubscriptionLevel() {
    const selectedNodes = this.interactiveSubscriptionLevelDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editInteractiveSubscriptionLevel(selectedData[0]);
    }

    return false;
  }

  copySelectedInteractiveSubscriptionLevelPurchaseUrl() {
    const selectedNodes = this.interactiveSubscriptionLevelDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.clipboard.copy(selectedData[0].purchaseUrl);
      MessageDialogComponent.showDialog(
        this.dialog,
        "Success",
        "'" + selectedData[0].purchaseUrl + "' copied to clipboard."
      );
    }

    return false;
  }

  resizeColumnsInteractiveSubscriptionLevel() {
    const allColumnIds = [];
    this.interactiveSubscriptionLevelDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.interactiveSubscriptionLevelDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  editInteractiveSubscriptionLevel(
    targetInteractiveSubscriptionLevel: InteractSubLevel
  ): boolean {
    let params: EditSubLevelsDialogData = {
      isNew: false,
      interactSubTypes: this.allInteractiveSubscriptions,
      allowDownload:
        targetInteractiveSubscriptionLevel.allowInteractiveDownload,
      allowModify: targetInteractiveSubscriptionLevel.allowModify,
      allowPurchase: targetInteractiveSubscriptionLevel.allowPurchase,
      maxAdminUsers: targetInteractiveSubscriptionLevel.maxAdminUsers,
      maxDesignerUsers: targetInteractiveSubscriptionLevel.maxDesignerUsers,
      maxDashboardUsers: targetInteractiveSubscriptionLevel.maxDashboardUsers,
      maxReportUsers: targetInteractiveSubscriptionLevel.maxReportUsers,
      description: targetInteractiveSubscriptionLevel.description,
      dialogTitle: "Edit Subscription Level",
      subscriptionLevelId:
        targetInteractiveSubscriptionLevel.interactSubLevelId,
      subscriptionTypeId: targetInteractiveSubscriptionLevel.interactSubTypeId,
      allowInvoice: targetInteractiveSubscriptionLevel.allowInvoice,
      allowPreFilter: targetInteractiveSubscriptionLevel.allowPreFilter,
      hasApiAccess: targetInteractiveSubscriptionLevel.hasApiAccess,
      unlimitedDataSetData: targetInteractiveSubscriptionLevel.unlimitedDataSetData,
      unlimitedSourceData: targetInteractiveSubscriptionLevel.unlimitedSourceData,
      monthlyDataSetDataRows: targetInteractiveSubscriptionLevel.monthlyDataSetDataRows,
      monthlySourceDataRows: targetInteractiveSubscriptionLevel.monthlySourceDataRows,
      allowPrintOnDemand: targetInteractiveSubscriptionLevel.allowPrintOnDemand,
      allowDataOnDemand: targetInteractiveSubscriptionLevel.allowDataOnDemand,
      hasAiChatAccess: targetInteractiveSubscriptionLevel.hasAiChatAccess,
      monthlyMaxTokens: targetInteractiveSubscriptionLevel.monthlyMaxTokens,
    };

    const dialogRef = this.dialog.open(EditSubLevelsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const editLevel: InteractSubLevels = {
          legacydonotusE_MaxSupport: 0,
          allowInteractiveDownload: params.allowDownload,
          allowModify: params.allowModify,
          allowPurchase: params.allowPurchase,
          maxAdminUsers: params.maxAdminUsers,
          maxDesignerUsers: params.maxDesignerUsers,
          maxDashboardUsers: params.maxDashboardUsers,
          maxReportUsers: params.maxReportUsers,
          interactSubLevelId: params.subscriptionLevelId,
          interactSubTypeId: params.subscriptionTypeId,
          description: params.description,
          fromValue: 0,
          pricingType: "",
          thruValue: 0,
          allowInvoice: params.allowInvoice,
          allowPreFilter: params.allowPreFilter,
          hasApiAccess: params.hasApiAccess,
          unlimitedDataSetData: params.unlimitedDataSetData,
          unlimitedSourceData: params.unlimitedSourceData,
          monthlyDataSetDataRows: params.monthlyDataSetDataRows,
          monthlySourceDataRows: params.monthlySourceDataRows,
          allowPrintOnDemand: params.allowPrintOnDemand,
          allowDataOnDemand: params.allowDataOnDemand,
          hasAiChatAccess: params.hasAiChatAccess,
          monthlyMaxTokens: params.monthlyMaxTokens,
        };

        this.adminInteractiveSubService
          .adminInteractiveSubEditSubscriptionLevel(editLevel)
          .subscribe((result) => {
            this.loadInteractiveSubscriptionLevels();
          });
      }
    });

    return false;
  }

  addInteractiveSubscriptionLevel(): boolean {
    let params: EditSubLevelsDialogData = {
      isNew: true,
      interactSubTypes: this.allInteractiveSubscriptions,
      allowDownload: false,
      allowModify: false,
      allowPurchase: false,
      maxAdminUsers: 0,
      maxDesignerUsers: 0,
      maxDashboardUsers: 0,
      maxReportUsers: 0,
      description: "",
      dialogTitle: "Add Subscription Level",
      subscriptionLevelId: -1,
      subscriptionTypeId: -1,
      allowInvoice: true,
      allowPreFilter: false,
      hasApiAccess: false,
      unlimitedDataSetData: false,
      unlimitedSourceData: false,
      monthlyDataSetDataRows: 0,
      monthlySourceDataRows: 0,
      allowPrintOnDemand: false,
      allowDataOnDemand: false,
      hasAiChatAccess: false,
      monthlyMaxTokens: 0,
    };

    const dialogRef = this.dialog.open(EditSubLevelsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const newLevel: InteractSubLevel = {
          legacydonotusE_MaxSupport: 0,
          allowInteractiveDownload: params.allowDownload,
          allowModify: params.allowModify,
          allowPurchase: params.allowPurchase,
          maxAdminUsers: params.maxAdminUsers,
          maxDesignerUsers: params.maxDesignerUsers,
          maxDashboardUsers: params.maxDashboardUsers,
          maxReportUsers: params.maxReportUsers,
          interactSubLevelId: -1,
          interactSubTypeId: params.subscriptionTypeId,
          description: params.description,
          fromValue: 0,
          pricingType: "",
          purchaseUrl: "",
          subTypeDescription: "",
          subTypeList: [],
          thruValue: 0,
          allowInvoice: params.allowInvoice,
          allowPreFilter: params.allowPreFilter,
          hasApiAccess: params.hasApiAccess,
          unlimitedDataSetData: params.unlimitedDataSetData,
          unlimitedSourceData: params.unlimitedSourceData,
          monthlyDataSetDataRows: params.monthlyDataSetDataRows,
          monthlySourceDataRows: params.monthlySourceDataRows,
          allowPrintOnDemand: params.allowPrintOnDemand,
          allowDataOnDemand: params.allowDataOnDemand,
          hasAiChatAccess: params.hasAiChatAccess,
          monthlyMaxTokens: params.monthlyMaxTokens,
        };

        this.adminInteractiveSubService
          .adminInteractiveSubCreateSubscriptionLevel(newLevel)
          .subscribe((result) => {
            this.loadInteractiveSubscriptionLevels();
          });
      }
    });

    return false;
  }

  loadInteractiveSubscriptionPrices() {
    this.loadingInteractiveSubscriptionPrices = true;
    this.adminInteractiveSubService
      .adminInteractiveSubGetSubscriptionPrices()
      .subscribe((result) => {
        this.allInteractiveSubscriptionPrices = result;
        this.loadingInteractiveSubscriptionPrices = false;
      });
  }

  editSelectedInteractiveSubscriptionPrice() {
    const selectedNodes = this.interactiveSubscriptionPriceDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editInteractiveSubscriptionPrice(selectedData[0]);
    }

    return false;
  }

  copySelectedInteractiveSubscriptionPricePurchaseUrl() {
    const selectedNodes = this.interactiveSubscriptionPriceDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.clipboard.copy(selectedData[0].purchaseUrl);
      MessageDialogComponent.showDialog(
        this.dialog,
        "Success",
        "'" + selectedData[0].purchaseUrl + "' copied to clipboard."
      );
    }

    return false;
  }

  resizeColumnsInteractiveSubscriptionPrice() {
    const allColumnIds = [];
    this.interactiveSubscriptionPriceDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.interactiveSubscriptionPriceDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  editInteractiveSubscriptionPrice(
    targetInteractiveSubscriptionPrice: InteractSubPrice
  ): boolean {
    let params: EditSubPricesDialogData = {
      dialogTitle: "Edit Subscription Price",
      interactSubLevels: this.allInteractiveSubscriptionLevels,
      interactSubTypes: this.allInteractiveSubscriptions,
      isNew: false,
      periodTypeId: targetInteractiveSubscriptionPrice.periodTypeId,
      price: targetInteractiveSubscriptionPrice.price,
      customTerms: targetInteractiveSubscriptionPrice.customerTerms,
      subPeriodTypes: this.allPeriodTypes,
      subscriptionLevelId:
        targetInteractiveSubscriptionPrice.interactSubLevelId,
      subscriptionTypeId: targetInteractiveSubscriptionPrice.interactSubTypeId,
      proposalFile: undefined,
      tax: targetInteractiveSubscriptionPrice.taxRate,
      clearProposal: false,
      suppressInvoice: targetInteractiveSubscriptionPrice.suppressInvoice
    };

    const dialogRef = this.dialog.open(EditSubPricesDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const editModel: AdminInteractiveSubService.AdminInteractiveSubCreateSubscriptionPriceParams = {
          InteractSubLevelId: params.subscriptionLevelId,
          InteractSubTypeId: params.subscriptionTypeId,
          PeriodTypeId: params.periodTypeId,
          Price: params.price,
          CustomTerms: params.customTerms,
          TaxRate: params.tax,
          ProposalUpload: params.proposalFile ?? undefined,
          ClearProposal: params.clearProposal,
          SuppressInvoice: params.suppressInvoice
        };

        this.adminInteractiveSubService
          .adminInteractiveSubEditSubscriptionPrice(editModel)
          .subscribe(
            (result) => {
              this.loadInteractiveSubscriptionPrices();
            },
            (error) => {}
          );
      }
    });

    return false;
  }

  addInteractiveSubscriptionPrice(): boolean {
    let params: EditSubPricesDialogData = {
      dialogTitle: "Add Subscription Price",
      interactSubLevels: this.allInteractiveSubscriptionLevels,
      interactSubTypes: this.allInteractiveSubscriptions,
      isNew: true,
      periodTypeId: -1,
      price: 0,
      customTerms: null,
      subPeriodTypes: this.allPeriodTypes,
      subscriptionLevelId: -1,
      subscriptionTypeId: -1,
      clearProposal: false,
      proposalFile: null,
      tax: null,
      suppressInvoice: false
    };

    const dialogRef = this.dialog.open(EditSubPricesDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const editModel: AdminInteractiveSubService.AdminInteractiveSubCreateSubscriptionPriceParams = {
          InteractSubLevelId: params.subscriptionLevelId,
          InteractSubTypeId: params.subscriptionTypeId,
          PeriodTypeId: params.periodTypeId,
          Price: params.price,
          CustomTerms: params.customTerms,
          ClearProposal: params.clearProposal,
          TaxRate: params.tax && params.tax > 0 ? params.tax : undefined,
          ProposalUpload: params.proposalFile ?? undefined,
          SuppressInvoice: params.suppressInvoice
        };

        this.adminInteractiveSubService
          .adminInteractiveSubCreateSubscriptionPrice(editModel)
          .subscribe(
            (result) => {
              this.loadInteractiveSubscriptionPrices();
            },
            (error) => {}
          );
      }
    });

    return false;
  }

  loadPeriodTypes() {
    this.loadingPeriodTypes = true;
    this.subPeriodTypesService
      .subPeriodTypesGetSubPeriodTypesAll()
      .subscribe((result) => {
        this.allPeriodTypes = result;
        this.loadingPeriodTypes = false;
      });
  }

  resizeColumnsSubscriptionPeriodType() {
    const allColumnIds = [];
    this.subscriptionPeriodTypeDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.subscriptionPeriodTypeDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }






  loadXmlaSubscriptions() {
    this.loadingXmlaSubscriptionData = true;
    this.adminXmlaSubscriptionService
      .adminXmlaSubscriptionGetXmlaSubscriptionTypes()
      .subscribe((result) => {
        this.allXmlaSubscriptions = result;
        this.loadingXmlaSubscriptionData = false;
      });
  }

  editSelectedXmlaSubscription() {
    const selectedNodes = this.xmlaSubscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editXmlaSubscription(selectedData[0]);
    }

    return false;
  }

  copySelectedXmlaSubscriptionPurchaseUrl() {
    const selectedNodes = this.xmlaSubscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.clipboard.copy(selectedData[0].purchaseUrl);
      MessageDialogComponent.showDialog(
        this.dialog,
        "Success",
        "'" + selectedData[0].purchaseUrl + "' copied to clipboard."
      );
    }

    return false;
  }

  resizeColumnsXmlaSubscription() {
    const allColumnIds = [];
    this.xmlaSubscriptionDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.xmlaSubscriptionDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  editXmlaSubscription(targetSubscription: XmlaSubscriptionTypeEx): boolean {
    const params: EditXmlaSubscriptionsDialogData = {
      dialogTitle: "Edit XMLA Subscription",
      isNew: false,
      xmlaSubscriptionTypeId: targetSubscription.xmlaSubscriptionTypeId,
      xmlaSubscriptionTypeName: targetSubscription.xmlaSubscriptionName,
      description: targetSubscription.description,
      licenseHtml: targetSubscription.licenseHtml,
    };

    const dialogRef = this.dialog.open(EditXmlaSubscriptionsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.adminXmlaSubscriptionService
          .adminXmlaSubscriptionEditXmlaSubscriptionType({
            subTypeId: result.ResultData.xmlaSubscriptionTypeId,
            model: {
              xmlaSubscriptionTypeId: result.ResultData.xmlaSubscriptionTypeId,
              description: result.ResultData.description,
              licenseHtml: result.ResultData.licenseHtml,
              xmlaSubscriptionName: result.ResultData.xmlaSubscriptionTypeName,
            },
          })
          .subscribe((result) => {
            this.loadXmlaSubscriptions();
          });
      }
    });

    return false;
  }

  addXmlaSubscription(): boolean {
    const params: EditXmlaSubscriptionsDialogData = {
      dialogTitle: "Create XMLA Subscription",
      isNew: true,
      xmlaSubscriptionTypeId: -1,
      xmlaSubscriptionTypeName: "",
      description: "",
      licenseHtml: ""
    };

    const dialogRef = this.dialog.open(EditXmlaSubscriptionsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.adminXmlaSubscriptionService
          .adminXmlaSubscriptionCreateXmlaSubscriptionType({
            xmlaSubscriptionName: result.ResultData.xmlaSubscriptionTypeName,
            description: result.ResultData.description,
            xmlaSubscriptionTypeId: -1,
            licenseHtml: result.ResultData.licenseHtml
          })
          .subscribe(
            (result) => {
              this.loadXmlaSubscriptions();
            },
            (error) => {}
          );
      }
    });

    return false;
  }

  loadXmlaSubscriptionLevels() {
    this.loadingXmlaSubscriptionLevels = true;
    this.adminXmlaSubscriptionService
      .adminXmlaSubscriptionGetXmlaSubscriptionLevelsAll()
      .subscribe((result) => {
        this.allXmlaSubscriptionLevels = result;
        this.loadingXmlaSubscriptionLevels = false;
      });
  }

  editSelectedXmlaSubscriptionLevel() {
    const selectedNodes = this.xmlaSubscriptionLevelDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editXmlaSubscriptionLevel(selectedData[0]);
    }

    return false;
  }

  deleteSelectedXmlaSubscriptionLevel() {
    const selectedNodes = this.xmlaSubscriptionLevelDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.deleteXmlaSubscriptionLevel(selectedData[0]);
    }

    return false;
  }

  copySelectedXmlaSubscriptionLevelPurchaseUrl() {
    const selectedNodes = this.xmlaSubscriptionLevelDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.clipboard.copy(selectedData[0].purchaseUrl);
      MessageDialogComponent.showDialog(
        this.dialog,
        "Success",
        "'" + selectedData[0].purchaseUrl + "' copied to clipboard."
      );
    }

    return false;
  }

  resizeColumnsXmlaSubscriptionLevel() {
    const allColumnIds = [];
    this.xmlaSubscriptionLevelDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.xmlaSubscriptionLevelDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  editXmlaSubscriptionLevel(
    targetSubscriptionLevel: XmlaSubscriptionLevelEx
  ): boolean {
    let params: EditXmlaSubscriptionLevelsDialogData = {
      dialogTitle: "Edit Subscription Level",
      isNew: false,
      xmlaSubscriptionTypes: this.allXmlaSubscriptions,
      subscriptionLevelId: targetSubscriptionLevel.xmlaSubscriptionLevelId,
      subscriptionTypeId: targetSubscriptionLevel.xmlaSubscriptionTypeId,
      description: targetSubscriptionLevel.description,
      allowInvoice: targetSubscriptionLevel.allowInvoice,
    };

    const dialogRef = this.dialog.open(
      EditXmlaSubscriptionLevelsDialogComponent,
      {
        disableClose: true,
        width: "500px",
        data: params,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = <EditXmlaSubscriptionLevelsDialogData>result.ResultData;
        this.adminXmlaSubscriptionService
          .adminXmlaSubscriptionEditSubscriptionLevel({
            subLevelId: params.subscriptionLevelId,
            subTypeId: params.subscriptionTypeId,
            model: {
              allowInvoice: params.allowInvoice,
              xmlaSubscriptionLevelId: params.subscriptionLevelId,
              xmlaSubscriptionTypeId: params.subscriptionTypeId,
              description: params.description,
              xmlaSubscriptionTypeDescription: "",
              pricingType: "",
              purchaseUrl: "",
            },
          })
          .subscribe((result) => {
            this.loadXmlaSubscriptionLevels();
          });
      }
    });

    return false;
  }

  deleteXmlaSubscriptionLevel(
    targetSubscriptionLevel: XmlaSubscriptionLevelEx
  ): boolean {
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Delete Subscription Level",
      "Are you sure you want to delete this level and all associated prices?"
    ).subscribe((confirmResult) => {
      if (confirmResult.ResultType === DialogResultType.Ok) {
        this.adminXmlaSubscriptionService.adminXmlaSubscriptionDeleteXmlaSubscriptionLevel({
          subTypeId: targetSubscriptionLevel.xmlaSubscriptionTypeId,
          subLevelId: targetSubscriptionLevel.xmlaSubscriptionLevelId
        }).subscribe(result => {
          this.loadXmlaSubscriptionLevels();
          this.loadXmlaSubscriptionPrices();
        })
      }
    });

    return false;
  }

  addXmlaSubscriptionLevel(): boolean {
    let params: EditXmlaSubscriptionLevelsDialogData = {
      dialogTitle: "Create Subscription Level",
      isNew: true,
      xmlaSubscriptionTypes: this.allXmlaSubscriptions,
      subscriptionLevelId: -1,
      subscriptionTypeId: -1,
      description: "",
      allowInvoice: true,
    };

    const dialogRef = this.dialog.open(
      EditXmlaSubscriptionLevelsDialogComponent,
      {
        disableClose: true,
        width: "500px",
        data: params,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;
        this.adminXmlaSubscriptionService
          .adminXmlaSubscriptionCreateXmlaSubscriptionLevel({
            xmlaSubscriptionLevelId: -1,
            xmlaSubscriptionTypeId: params.subscriptionTypeId,
            description: params.description,
            allowInvoice: params.allowInvoice,
          })
          .subscribe(
            (result) => {
              this.loadXmlaSubscriptionLevels();
            },
            (error) => {
              var t = 0;
            }
          );
      }
    });

    return false;
  }

  loadXmlaSubscriptionPrices() {
    this.loadingXmlaSubscriptionPrices = true;
    this.adminXmlaSubscriptionService
      .adminXmlaSubscriptionGetXmlaSubscriptionPrices()
      .subscribe((result) => {
        this.allXmlaSubscriptionPrices = result;
        this.loadingXmlaSubscriptionPrices = false;
      });
  }

  editSelectedXmlaSubscriptionPrice() {
    const selectedNodes = this.xmlaSubscriptionPriceDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editXmlaSubscriptionPrice(selectedData[0]);
    }

    return false;
  }

  deleteSelectedXmlaSubscriptionPrice() {
    const selectedNodes = this.xmlaSubscriptionPriceDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.deleteXmlaSubscriptionPrice(selectedData[0]);
    }

    return false;
  }

  resizeColumnsXmlaSubscriptionPrice() {
    const allColumnIds = [];
    this.xmlaSubscriptionPriceDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.xmlaSubscriptionPriceDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  editXmlaSubscriptionPrice(
    targetSubscriptionPrice: XmlaSubscriptionPriceEx
  ): boolean {
    let params: EditXmlaSubscriptionPricesDialogData = {
      dialogTitle: "Edit Subscription Price",
      isNew: false,
      xmlaSubscriptionTypes: this.allXmlaSubscriptions,
      xmlaSubscriptionLevels: this.allXmlaSubscriptionLevels,
      subPeriodTypes: this.allPeriodTypes,
      subscriptionTypeId: targetSubscriptionPrice.xmlaSubscriptionTypeId,
      subscriptionLevelId: targetSubscriptionPrice.xmlaSubscriptionLevelId,
      periodTypeId: targetSubscriptionPrice.periodTypeId,
      price: targetSubscriptionPrice.price,
    };

    const dialogRef = this.dialog.open(
      EditXmlaSubscriptionPricesDialogComponent,
      {
        disableClose: true,
        width: "500px",
        data: params,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = <EditXmlaSubscriptionPricesDialogData>result.ResultData;
        this.adminXmlaSubscriptionService
          .adminXmlaSubscriptionEditSubscriptionPrice({
            periodId: params.periodTypeId,
            subLevelId: params.subscriptionLevelId,
            subTypeId: params.subscriptionTypeId,
            model: {
              periodTypeId: params.periodTypeId,
              xmlaSubscriptionLevelId: params.subscriptionLevelId,
              xmlaSubscriptionTypeId: params.subscriptionTypeId,
              periodDescription: "",
              price: params.price,
              periodType: null,
              subscriptionLevelDescription: "",
              subscriptionTypeDescription: "",
              xmlaSubscriptionLevel: null,
            },
          })
          .subscribe((result) => {
            this.loadXmlaSubscriptionPrices();
          });
        //Do something here!
      }
    });

    return false;
  }

  deleteXmlaSubscriptionPrice(
    targetSubscriptionPrice: XmlaSubscriptionPriceEx
  ): boolean {

    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Delete Subscription Price",
      "Are you sure you want to delete this price?"
    ).subscribe((confirmResult) => {
      if (confirmResult.ResultType === DialogResultType.Ok) {
        this.adminXmlaSubscriptionService.adminXmlaSubscriptionDeleteSubscriptionPrice({
          periodId: targetSubscriptionPrice.periodTypeId,
          subTypeId: targetSubscriptionPrice.xmlaSubscriptionTypeId,
          subLevelId: targetSubscriptionPrice.xmlaSubscriptionLevelId
        }).subscribe(result => {
          this.loadXmlaSubscriptionPrices();
        })
      }
    });

    return false;
  }

  addXmlaSubscriptionPrice(): boolean {
    const params: EditXmlaSubscriptionPricesDialogData = {
      dialogTitle: "Create Subscription Price",
      isNew: true,
      xmlaSubscriptionTypes: this.allXmlaSubscriptions,
      xmlaSubscriptionLevels: this.allXmlaSubscriptionLevels,
      subPeriodTypes: this.allPeriodTypes,
      subscriptionTypeId: -1,
      subscriptionLevelId: -1,
      periodTypeId: -1,
      price: 0,
    };

    const dialogRef = this.dialog.open(
      EditXmlaSubscriptionPricesDialogComponent,
      {
        disableClose: true,
        width: "500px",
        data: params,
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.adminXmlaSubscriptionService
          .adminXmlaSubscriptionCreateSubscriptionPrice({
            xmlaSubscriptionTypeId: result.ResultData.subscriptionTypeId,
            xmlaSubscriptionLevelId: result.ResultData.subscriptionLevelId,
            periodTypeId: result.ResultData.periodTypeId,
            price: result.ResultData.price,
          })
          .subscribe(
            (result) => {
              this.loadXmlaSubscriptionPrices();
            },
            (error) => {}
          );
      }
    });

    return false;
  }



  loadSubscriptions() {
    this.loadingSubscriptions = true;
    this.subHeadersService.subHeadersGetSubHeadersAll().subscribe((result) => {
      this.allSubscriptions = result;
      //this.newFilterSubscriptions('');
      //this.filteredSubscriptions.next(this.allSubscriptions.slice());
      this.loadingSubscriptions = false;

      if (this.currentlySelectedSubscription) {
        this.currentlySelectedSubscription = this.allSubscriptions.find(x => x.subscriptionId === this.currentlySelectedSubscription.subscriptionId);
      }
    });

    this.loadingDeletedSubscriptions = true;
    this.subHeadersService.subHeadersGetDeletedSubHeaders().subscribe((result) => {
      this.allDeletedSubscriptions = result;
      //this.newFilterSubscriptions('');
      //this.filteredSubscriptions.next(this.allSubscriptions.slice());
      this.loadingDeletedSubscriptions = false;
    });
  }

  editSelectedSubscription() {
    const selectedNodes = this.subscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editSubscription(selectedData[0]);
    }

    return false;
  }

  deleteSelectedSubscription() {
    const selectedNodes = this.subscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Subscription",
        "Are you sure you want to delete this subscription?  This is a soft delete and can be undone."
      ).subscribe((result) => {
        if (result.ResultType === DialogResultType.Ok) {
          this.deleteSubscription(selectedData[0]);
        }
      });
    }

    return false;
  }

  unDeleteSelectedSubscription() {
    const selectedNodes = this.deletedSubscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Subscription",
        "Are you sure you want to un-delete this subscription?"
      ).subscribe((result) => {
        if (result.ResultType === DialogResultType.Ok) {
          this.subHeadersService.subHeadersUnDeleteSubscription(selectedData[0].subscriptionId).subscribe(result => {
            if (result) {
              this.loadSubscriptions();
            } else {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error",
                "Failed to un-delete subscriptions."
              );
            }
          })
        }
      });
    }

    return false;
  }

  cancelSelectedSubscription() {
    const selectedNodes = this.subscriptionDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.cancelSubscription(selectedData[0]);
    }

    return false;
  }

  resizeColumnsSubscription() {
    const allColumnIds = [];
    this.subscriptionDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.subscriptionDataGrid.columnApi.autoSizeColumns(allColumnIds, false);

    return false;
  }

  editSubscription(targetSubscription: SubscriptionHeader): boolean {
    let params: EditSubscriptionDialogData = {
      address1: targetSubscription.addressLine1,
      address2: targetSubscription.addressLine2,
      autoRenew: targetSubscription.autoRenew,
      maxAdminUsers: targetSubscription.maxAdminUsers,
      maxDesignerUsers: targetSubscription.maxDesignerUsers,
      maxDashboardUsers: targetSubscription.maxDashboardUsers,
      maxReportUsers: targetSubscription.maxReportUsers,
      city: targetSubscription.city,
      createdDate: new Date(targetSubscription.createdDate),
      dialogTitle: "Edit Subscription",
      expirationDate: new Date(targetSubscription.expireDate),
      isNew: false,
      periodTypeId: targetSubscription.periodTypeId,
      allPeriodTypes: this.allPeriodTypes,
      phone: targetSubscription.phone,
      state: targetSubscription.state,
      subscriptionLevel:
        targetSubscription.subscriptionLevelName == null ||
        targetSubscription.subscriptionLevelName == ""
          ? targetSubscription.interactSubLevelName
          : targetSubscription.subscriptionName,
      subscriptionName: targetSubscription.subscriptionName,
      subscriptionType:
        targetSubscription.subscriptionTypeName == null ||
        targetSubscription.subscriptionTypeName == ""
          ? targetSubscription.interactSubTypeName
          : targetSubscription.subscriptionTypeName,
      taxExemptExpireDate:
        targetSubscription.taxExemptExpireDate == null
          ? null
          : new Date(targetSubscription.taxExemptExpireDate),
      taxExemptId: targetSubscription.taxExemptId,
      zip: targetSubscription.zip,
      organizationName: targetSubscription.organizationName,
      purchaserFirstName: targetSubscription.purchaserFirstName,
      purchaserLastName: targetSubscription.purchaserLastName,
      purchaserTitle: targetSubscription.purchaserTitle,
      purchaserEmail: targetSubscription.purchaserEmail,
      purchaserPhone: targetSubscription.purchaserPhone,
    };

    const dialogRef = this.dialog.open(EditSubscriptionDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData as EditSubscriptionDialogData;

        const saveData: SubHeadersService.SubHeadersPutSubHeadersParams = {
          id: targetSubscription.subscriptionId,
          subHeaders: {
            legacydonotusE_MaxSupport: 0,
            addressLine1: params.address1,
            addressLine2: params.address2,
            autoRenew: params.autoRenew,
            maxAdminUsers: params.maxAdminUsers,
            maxDesignerUsers: params.maxDesignerUsers,
            maxDashboardUsers: params.maxDashboardUsers,
            maxReportUsers: params.maxReportUsers,
            city: params.city,
            createdDate: params.createdDate.toLocaleString(),
            expireDate: params.expirationDate.toLocaleString(),
            periodTypeId: params.periodTypeId,
            phone: params.phone,
            state: params.state,
            taxExemptExpireDate:
              params.taxExemptExpireDate !== null
                ? params.taxExemptExpireDate.toLocaleString()
                : "",
            taxExemptId: params.taxExemptId,
            zip: params.zip,

            autoAddEmail: targetSubscription.autoAddEmail,
            autoAddEmailDomain: targetSubscription.autoAddEmailDomain,
            autoRenewAgreementTimestamp:
              targetSubscription.autoRenewAgreementTimestamp,
            autoRenewPayPalProfileId:
              targetSubscription.autoRenewPayPalProfileId,
            subscriptionId: targetSubscription.subscriptionId,
            createdTimeStamp: targetSubscription.createdTimeStamp,
            entityId: targetSubscription.entityId,
            entityType: targetSubscription.entityType,
            interactSubLevelId: targetSubscription.interactSubLevelId,
            interactSubTypeId: targetSubscription.interactSubTypeId,
            modifiedTimeStamp: targetSubscription.modifiedTimeStamp,
            organizationName: params.organizationName,
            purchaserEmail: params.purchaserEmail,
            purchaserFirstName: params.purchaserFirstName,
            purchaserLastName: params.purchaserLastName,
            purchaserPhone: params.purchaserPhone,
            purchaserTitle: params.purchaserTitle,
            subscriptionName: targetSubscription.subscriptionName,
            xmlaSubscriptionLevelId: targetSubscription.xmlaSubscriptionLevelId,
            xmlaSubscriptionToken: targetSubscription.xmlaSubscriptionToken,
            xmlaSubscriptionTypeId: targetSubscription.xmlaSubscriptionTypeId,
            apiSubscriptionToken: targetSubscription.apiSubscriptionToken,
            searchApiKey: targetSubscription.searchApiKey,
            isDeleted: targetSubscription.isDeleted,
          },
        };
        this.subHeadersService.subHeadersPutSubHeaders(saveData).subscribe(
          (result) => {
            this.loadSubscriptions();
          },
          (error) => {}
        );
        //Do something here!
      }
    });

    return false;
  }

  deleteSubscription(targetSubscription: SubscriptionHeader): boolean {
    this.subHeadersService.subHeadersDeleteSubscription(targetSubscription.subscriptionId).subscribe(result => {
      if (result) {
        this.loadSubscriptions();
      } else {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Error",
          "Failed to delete subscriptions."
        );
      }
    })

    return false;
  }

  cancelSubscription(targetSubscription: SubscriptionHeader): boolean {
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Cancel Subscription",
      "Are you sure you want to cancel this subscription?  This will set the thru date to yesterday, effectively canceling the subscription."
    ).subscribe((confirmResult) => {
      if (confirmResult.ResultType === DialogResultType.Ok) {
        const saveData: SubHeadersService.SubHeadersPutSubHeadersParams = {
          id: targetSubscription.subscriptionId,
          subHeaders: {
            legacydonotusE_MaxSupport: 0,
            addressLine1: targetSubscription.addressLine1,
            addressLine2: targetSubscription.addressLine2,
            autoRenew: targetSubscription.autoRenew,
            maxAdminUsers: targetSubscription.maxAdminUsers,
            maxDesignerUsers: targetSubscription.maxDesignerUsers,
            maxDashboardUsers: targetSubscription.maxDashboardUsers,
            maxReportUsers: targetSubscription.maxReportUsers,
            city: targetSubscription.city,
            createdDate: targetSubscription.createdDate.toLocaleString(),
            expireDate: (new Date(Date.now() - 1)).toLocaleString(),
            periodTypeId: targetSubscription.periodTypeId,
            phone: targetSubscription.phone,
            state: targetSubscription.state,
            taxExemptExpireDate:
              targetSubscription.taxExemptExpireDate !== null
                ? targetSubscription.taxExemptExpireDate.toLocaleString()
                : "",
            taxExemptId: targetSubscription.taxExemptId,
            zip: targetSubscription.zip,

            autoAddEmail: targetSubscription.autoAddEmail,
            autoAddEmailDomain: targetSubscription.autoAddEmailDomain,
            autoRenewAgreementTimestamp:
            targetSubscription.autoRenewAgreementTimestamp,
            autoRenewPayPalProfileId:
            targetSubscription.autoRenewPayPalProfileId,
            subscriptionId: targetSubscription.subscriptionId,
            createdTimeStamp: targetSubscription.createdTimeStamp,
            entityId: targetSubscription.entityId,
            entityType: targetSubscription.entityType,
            interactSubLevelId: targetSubscription.interactSubLevelId,
            interactSubTypeId: targetSubscription.interactSubTypeId,
            modifiedTimeStamp: targetSubscription.modifiedTimeStamp,
            organizationName: targetSubscription.organizationName,
            purchaserEmail: targetSubscription.purchaserEmail,
            purchaserFirstName: targetSubscription.purchaserFirstName,
            purchaserLastName: targetSubscription.purchaserLastName,
            purchaserPhone: targetSubscription.purchaserPhone,
            purchaserTitle: targetSubscription.purchaserTitle,
            subscriptionName: targetSubscription.subscriptionName,
            xmlaSubscriptionLevelId: targetSubscription.xmlaSubscriptionLevelId,
            xmlaSubscriptionToken: targetSubscription.xmlaSubscriptionToken,
            xmlaSubscriptionTypeId: targetSubscription.xmlaSubscriptionTypeId,
            isDeleted: targetSubscription.isDeleted,
          },
        };
        this.subHeadersService.subHeadersPutSubHeaders(saveData).subscribe(
          (result) => {
            this.loadSubscriptions();

          },
          (error) => {}
        );
      }
    });
    return false;
  }

  loadUnpaidOrders() {
    this.loadingUnpaidOrders = true;
    this.unpaidOrdersService
      .unpaidOrdersGetUnpaidOrders()
      .subscribe((result) => {
        this.allUnpaidOrders = result;
        this.loadingUnpaidOrders = false;
      });
  }

  renderUnpaidOrderAdmins(params) {
    const divElement = document.createElement("div");
    let result = "<table>";
    for (let i = 0; i < params.data.userNames.length; i++) {
      result += "<tr><td>" + params.data.userNames[i] + "</td></tr>";
    }
    result += "</table>";
    divElement.innerHTML = result;
    return divElement;
  }

  processSelectedOrderPayment() {
    const selectedNodes = this.unpaidOrderDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.processOrderPayment(selectedData[0]);
    }

    return false;
  }

  resizeColumnsUnpaidOrder() {
    const allColumnIds = [];
    this.unpaidOrderDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.unpaidOrderDataGrid.columnApi.autoSizeColumns(allColumnIds, false);

    return false;
  }

  onUnpaidOrderColumnVisible(params) {
    this.unpaidOrderDataGrid.api.resetRowHeights();
  }

  onUnpaidOrderColumnResized(params) {
    this.unpaidOrderDataGrid.api.resetRowHeights();
  }

  processOrderPayment(targetOrder: UnpaidOrderViewModel) {
    const params: EditUnpaidOrderDialogData = {
      amountPaid: 0,
      dialogTitle: "Process Payment",
      isNew: false,
      orderTotal: targetOrder.totalDue,
      paymentDate: null,
      previouslyPaid: targetOrder.totalPaid,
      subscriptionName: targetOrder.subscriptionName,
      totalDue: targetOrder.amountRemaining,
    };

    const dialogRef = this.dialog.open(EditUnpaidOrderDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        targetOrder.newPaymentAmount = result.ResultData.amountPaid;
        targetOrder.paidDate = result.ResultData.paymentDate;

        this.unpaidOrdersService
          .unpaidOrdersEditUnpaidOrder(targetOrder)
          .subscribe(
            (result) => {
              this.loadUnpaidOrders();
            },
            (error) => {}
          );
      }
    });

    return false;
  }

  loadSubscriptionUsers() : Promise<void> {
    this.loadingSubscriptionUsers = true;
    return new Promise<void>((resolve, error) => {
      this.subscriptionUsersService
        .subscriptionUsersGetSubscriptionUsers()
        .subscribe((result) => {
          this.allSubscriptionUsers = result;
          this.loadingSubscriptionUsers = false;

          resolve();
        });
    });
  }

  resizeColumnsSubscriptionUser() {
    const allColumnIds = [];
    this.subscriptionuserDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.subscriptionuserDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  renderSubscriptionUsers(params) {
    const divElement = document.createElement("div");
    let result = '<table border="1">';
    result +=
      "<tr><th>ID</th><th>Name</th><th>Email Address</th><th>Confirmed?</th></tr>";
    for (let i = 0; i < params.data.users.length; i++) {
      const user = params.data.users[i];
      result +=
        "<tr><td>" +
        user.id +
        "</td><td>" +
        user.name +
        "</td><td>" +
        user.emailAddress +
        "</td><td>" +
        user.confirmed +
        "</td></tr>";
    }
    result += "</table>";
    divElement.innerHTML = result;
    return divElement;
  }

  onSubscriptionUsersColumnVisible(params) {
    this.subscriptionuserDataGrid.api.resetRowHeights();
  }

  onSubscriptionUnRegisteredUsersColumnVisible(params) {
    this.subscriptionUnRegisteredUsersDataGrid.api.resetRowHeights();
  }

  onSubscriptionUsersColumnResized(params) {
    this.subscriptionuserDataGrid.api.resetRowHeights();
  }

  onSubscriptionUnRegisteredUsersColumnResized(params) {
    this.subscriptionUnRegisteredUsersDataGrid.api.resetRowHeights();
  }

  loadCoupons() {
    this.loadingCoupons = true;
    this.adminCouponsService.adminCouponsGetCouponsAll().subscribe((result) => {
      this.allCoupons = result;
      this.loadingCoupons = false;
    });
  }

  editSelectedCouponCode() {
    const selectedNodes = this.couponcodeDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editCouponCode(selectedData[0]);
    }

    return false;
  }

  editSelectedCouponLevels() {
    const selectedNodes = this.couponcodeDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editCouponLevels(selectedData[0]);
    }

    return false;
  }

  resizeColumnsCouponCode() {
    const allColumnIds = [];
    this.couponcodeDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.couponcodeDataGrid.columnApi.autoSizeColumns(allColumnIds, false);

    return false;
  }

  editCouponCode(coupon: Coupons): boolean {
    let params: EditCouponsDialogData = {
      dialogTitle: "Edit Coupon",
      isNew: false,
      couponCode: coupon.couponCode,
      description: coupon.description,
      startDate: coupon.startDate,
      expirationDate: coupon.endDate,
      oneTimeUse: coupon.oneTimeUse,
      couponType: coupon.couponType,
      freeTrialLength: coupon.freeTrialPeriodType,
      discountPercent: coupon.discountPercent,
      discountAmount: coupon.discountAmount,
      active: coupon.active,
    };

    const dialogRef = this.dialog.open(EditCouponsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const createParams: AdminCouponsService.AdminCouponsPutCouponsParams = {
          id: params.couponCode,
          coupons: {
            couponCode: params.couponCode,
            description: params.description,
            startDate: params.startDate == "" ? null : params.startDate,
            endDate: params.expirationDate,
            oneTimeUse: params.oneTimeUse,
            couponType: params.couponType,
            freeTrialPeriodType:
              params.freeTrialLength == 0 ? null : params.freeTrialLength,
            discountPercent:
              params.discountPercent == 0 ? null : params.discountPercent,
            discountAmount:
              params.discountAmount == 0 ? null : params.discountAmount,
            active: params.active,
          },
        };

        this.adminCouponsService.adminCouponsPutCoupons(createParams).subscribe(
          (result) => {
            this.loadCoupons();
            MessageDialogComponent.showDialog(
              this.dialog,
              "Success",
              "Coupon Updated"
            ).subscribe((result) => {});
          },
          (error) => {
            MessageDialogComponent.showDialog(
              this.dialog,
              "Error",
              "Failed To Update Coupon"
            ).subscribe((result) => {});
          }
        );
      }
    });

    return false;
  }

  editCouponLevels(coupon: Coupons): boolean {
    const params: EditCouponLevelsDialogData = {
      isNew: false,
      dialogTitle: "Coupon Levels",
      couponCode: coupon.couponCode,
      adminCouponLevelsService: this.adminCouponLevelssService,
      adminInteractiveSubService: this.adminInteractiveSubService,
      reportExportService: this.reportExportService,
    };

    const dialogRef = this.dialog.open(EditCouponLevelsDialogComponent, {
      disableClose: true,
      width: "750px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        //Do something here!
      }
    });

    return false;
  }

  addCouponCode(): boolean {
    let params: EditCouponsDialogData = {
      dialogTitle: "Create Coupon",
      isNew: true,
      couponCode: "",
      description: "",
      startDate: null,
      expirationDate: "",
      oneTimeUse: false,
      couponType: "F",
      freeTrialLength: null,
      discountPercent: null,
      discountAmount: null,
      active: false,
    };

    const dialogRef = this.dialog.open(EditCouponsDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const coupons: Coupons = {
          couponCode: params.couponCode,
          description: params.description,
          startDate: params.startDate,
          endDate: params.expirationDate,
          oneTimeUse: params.oneTimeUse,
          couponType: params.couponType,
          freeTrialPeriodType: params.freeTrialLength,
          discountPercent: params.discountPercent,
          discountAmount: params.discountAmount,
          active: params.active,
        };

        this.adminCouponsService.adminCouponsPostCoupons(coupons).subscribe(
          (result) => {
            this.loadCoupons();
            MessageDialogComponent.showDialog(
              this.dialog,
              "Success",
              "Coupon Created"
            ).subscribe((result) => {});
          },
          (error) => {
            MessageDialogComponent.showDialog(
              this.dialog,
              "Error",
              "Failed To Create Coupon"
            ).subscribe((result) => {});
          }
        );
      }
    });

    return false;
  }

  loadUsers() {
    this.loadingUsers = true;
    this.adminUserService.adminUsersGetUsers().subscribe((result) => {
      this.allUsers = result;
      this.filterSelectedSubscriptionUsers();
      this.loadingUsers = false;
    });
  }

  editSelectedUser() {
    const selectedNodes = this.userDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editUser(selectedData[0]);
    }

    return false;
  }

  impersonateSelectedUser() {
    const selectedData = this.userDataGrid.api.getSelectedNodes().map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(this.dialog, "Error", "You must select a row first.");
      return false;
    }

    const target = selectedData[0];
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Impersonation",
      "Impersonate " + (target.userName || "user " + target.userId) + "? You will see the application exactly as this user does until you exit impersonation."
    ).subscribe((result) => {
      if (result.ResultType === DialogResultType.Ok) {
        this.app.startImpersonation(target.userId).subscribe({
          error: (error) => {
            MessageDialogComponent.showDialog(
              this.dialog,
              "Error",
              "Unable to impersonate user: " + (error?.error?.message ?? error?.error ?? error?.message ?? "unknown error")
            );
          },
        });
      }
    });

    return false;
  }

  addUser() {

    const dialogRef = this.dialog.open(AddSubscriptionUserDialogComponent, {
      disableClose: true,
      width: "500px",
      data: {
        showConsultingRole: true
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        const request: UpdateUserSubscriptionRequest = {
          subscriptionId: this.currentlySelectedSubscription.subscriptionId,
          users: [
            {
              userType: result.ResultData.userType,
              delete: false,
              emailAddress: result.ResultData.emailAddress,
              userManager: result.ResultData.userManager,
              invoiceManager: result.ResultData.invoiceManager,
            },
          ],
        };

        this.subscriptionService
          .subscriptionUpdateUserSubscription(request)
          .subscribe((result) => {
            if (result !== "") {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error Adding User",
                result
              );
            } else {
              this.loadSubscriptionUsers().then(() => {
                this.filterSelectedSubscriptionUsers();
              });
            }
          });
      }
    });

    return false;
  }

  resizeColumnsUser() {
    const allColumnIds = [];
    this.userDataGrid.columnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.getColId());
    });
    this.userDataGrid.columnApi.autoSizeColumns(allColumnIds, false);

    return false;
  }

  editUser(targetUser: subscriptionDetailsUser): boolean {
    let params: EditUserDialogData = {
      dialogTitle: "Edit User",
      isNew: false,
      userName: targetUser.userName,
      firstName: targetUser.firstName,
      lastName: targetUser.lastName,
      title: targetUser.title,
      termsAgreement: targetUser.termsAgreement,
      active: targetUser.active,
      emailConfirmed: targetUser.emailConfirmed,
      company: targetUser.company,
      currentRole: targetUser.userType,
      invoiceManager: targetUser.invoiceManager,
      userManager: targetUser.userManager
    };

    const dialogRef = this.dialog.open(EditUserDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        params = result.ResultData;

        const updateParam: AdminUsersService.AdminUsersPutUserParams = {
          id: targetUser.userId,
          users: {
            ...targetUser,
            firstName: params.firstName,
            lastName: params.lastName,
            title: params.title,
            termsAgreement: params.termsAgreement,
            active: params.active,
            emailConfirmed: params.emailConfirmed,
            company: params.company,
            userName: params.userName,
            invoiceManager: params.invoiceManager,
            userManager: params.userManager
          },
        };

        this.adminUserService.adminUsersPutUser(updateParam).subscribe(
          (result) => {

            this.adminUserService.adminUsersUpdateSubscriptionUserRole({
              subscriptionId: this.currentlySelectedSubscription.subscriptionId,
              userId: targetUser.userId,
              newRole: params.currentRole,
              isUserMamanger: params.userManager,
              isInvoiceManager: params.invoiceManager
            }).subscribe(result => {
              this.loadSubscriptionUsers().then(() => {
                this.loadUsers();

                MessageDialogComponent.showDialog(
                  this.dialog,
                  "Success",
                  "User Updated"
                ).subscribe((result) => {});
              })
            })
          },
          (error) => {
            MessageDialogComponent.showDialog(
              this.dialog,
              "Error",
              "Failed To Update User"
            ).subscribe((result) => {});
          }
        );
/*
        const request: UpdateUserSubscriptionRequest = {
          subscriptionId: this.currentlySelectedSubscription.subscriptionId,
          users: [
            {
              userType: params.currentRole,
              delete: false,
              emailAddress: param.emailAddress,
              userManager: targetUs
            }
          ],
        };

 */
      }
    });

    return false;
  }

  deleteUser(targetUser: subscriptionDetailsUser): boolean {

    ConfirmDialogComponent.showDialog(this.dialog, "Delete User?", "Are you sure you want to remove this user from the subscription?").subscribe(result => {
      if(result.ResultType === DialogResultType.Ok) {

        const request: UpdateUserSubscriptionRequest = {
          subscriptionId: this.currentlySelectedSubscription.subscriptionId,
          users: [
            {
              delete: true,
              emailAddress: targetUser.emailAddress,
              userType: 3,
              userManager: false,
              invoiceManager: false,
            },
          ],
        };

        this.subscriptionService.subscriptionUpdateUsersSubscription(request).subscribe(result => {
          this.loadSubscriptionUsers().then(() => {
            this.filterSelectedSubscriptionUsers();
          });
        });
      }
    });

    return false;
  }

  loadModifiedInteractives(filter: boolean = false) {
    this.loadingModifiedInteractives = true;
    this.adminModifiedInteractiveService
      .adminModifiedInteractiveGetModifiedInteractives()
      .subscribe((result) => {
        this.allModifiedInteractives = result;
        this.loadingModifiedInteractives = false;
        if (filter) {
          this.filterSelectedSubscriptionInteractives();
        }
      });
  }

  resizeColumnsModifiedInteractives() {
    const allColumnIds = [];
    this.modifiedinteractiveDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.modifiedinteractiveDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }


  resizeColumnsSubscriptionUsersDetails() {
    const allColumnIds = [];
    this.subscriptionUsersDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.subscriptionUsersDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  resizeColumnsSubscriptionUnRegisteredUsersDetails() {
    const allColumnIds = [];
    this.subscriptionUnRegisteredUsersDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.subscriptionUnRegisteredUsersDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  onSubscriptionUsersDetailsColumnVisible(params) {
    this.subscriptionUsersDataGrid.api.resetRowHeights();
  }

  editSelectedDetailsSubscription() {
    this.editSubscription(this.currentlySelectedSubscription);
  }

  cancelSelectedDetailsSubscription() {
    this.cancelSubscription(this.currentlySelectedSubscription);
  }

  deleteSelectedDetailsSubscription() {
    ConfirmDialogComponent.showDialog(this.dialog, "Confirm Delete", "Are you sure you want to delete this subscription?  This is a soft delete and can be undone").subscribe(result => {
      if(result.ResultType === DialogResultType.Ok) {
        this.subHeadersService.subHeadersDeleteSubscription(this.currentlySelectedSubscription.subscriptionId).subscribe(result => {
          MessageDialogComponent.showDialog(this.dialog, "Deleted", "Subscription Deleted.").subscribe(_ => {
            this.loadSubscriptions();
            this.currentlySelectedSubscription = undefined;
            this.filteredSubscriptions.next(this.newFilterSubscriptions(this.lastSearch));
          })
        })
      }
    });
  }

  editSelectedDetailsUser() {
    const selectedNodes = this.subscriptionUsersDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.editUser(selectedData[0]);
    }

    return false;
  }

  deleteSelectedDetailsUser() {
    const selectedNodes = this.subscriptionUsersDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.deleteUser(selectedData[0]);
    }

    return false;
  }

  deleteInvitation() {

    const selectedNodes = this.subscriptionUnRegisteredUsersDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.deleteUser(selectedData[0]);
    }

    return false;
  }

  resendInvitationEmail() {
    const selectedNodes = this.subscriptionUnRegisteredUsersDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      var selectedUser: subscriptionDetailsUser = selectedData[0];
      this.subscriptionService.subscriptionSendSubscriptionInvitationEmail({
        subscriptionId: this.currentlySelectedSubscription.subscriptionId,
        subUserId: selectedUser.subUserId
      }).subscribe(result => {
        MessageDialogComponent.showDialog(
          this.dialog,
          "Complete",
          "Invitation Email Re-Sent"
        );
      });

    }
    return false;
  }

  resizeColumnsSubscriptionDetailsInteractives() {
    const allColumnIds = [];
    this.subscriptionModifedInteractivesDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.subscriptionModifedInteractivesDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }

  onFirstDataRendered($event: any) {
    $event.api.sizeColumnsToFit();
  }

  loadInteractiveAsSelectedUser() {
    const selectedNodes = this.subscriptionInteractsDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1 || !this.selectedAsUser) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a user and interactive first."
      );
    } else {
      const selectedInteractive: Interacts = selectedData[0];
      this.subscriptionService.subscriptionGetUserSubscriptionState(this.selectedAsUser.userId).subscribe(userState => {
        this.powerBi.loadInteractiveState(
          true,
          this.selectedAsUser.userId,
          selectedInteractive.interactId.toString(),
          "Interactive",
          "view",
          "-1",
          undefined,
          undefined,
          undefined,
          userState);

        this.showPowerBi = true;
      });
    }
  }

  editInteractiveAsSelectedUser() {
    const selectedNodes = this.subscriptionModifedInteractivesDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1 || !this.selectedAsUser) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a user and interactive first."
      );
    } else {
      const selectedInteractive: ModifiedInteractiveDetails = selectedData[0];
      this.subscriptionService.subscriptionGetUserSubscriptionState(this.selectedAsUser.userId).subscribe(userState => {
        this.powerBi.loadInteractiveState(
          true,
          this.selectedAsUser.userId,
          selectedInteractive.modifiedInteractiveId.toString(),
          "ModifiedInteractive",
          "edit",
          undefined,
          undefined,
          undefined,
          userState);

        this.showPowerBi = true;
      });
    }
  }

  deleteSpecificModifiedInteractive(modifiedInteractiveId: number) : Promise<void> {
    return new Promise<void>((resolve, error) => {
      this.adminModifiedInteractiveService.adminModifiedInteractiveDeleteModifiedInteractive(modifiedInteractiveId).subscribe(result => {
        if (result) {
          resolve();
        }
      });
    });
  }

  permanentDeleteSpecificModifiedInteractive(modifiedInteractiveId: number) : Promise<void> {
    return new Promise<void>((resolve, error) => {
      this.adminModifiedInteractiveService.adminModifiedInteractiveDeleteModifiedInteractivePermanent(modifiedInteractiveId).subscribe(result => {
        if (result) {
          resolve();
        }
      });
    });
  }

  deleteModifiedInteractive() {
    const selectedNodes = this.modifiedinteractiveDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a modified interactive first."
      );
    } else {
      const selectedInteractive: ModifiedInteractiveDetails = selectedData[0];
      ConfirmDialogComponent.showDialog(this.dialog, "Confirm Delete Modified Interactive", "Are you sure you want to delete this modified interactive?").subscribe(result => {
        if (result.ResultType === DialogResultType.Ok) {
          this.deleteSpecificModifiedInteractive(selectedInteractive.modifiedInteractiveId).then(() => {
            this.loadModifiedInteractives();
          });
        }
      });
    }
  }

  permanentDeleteModifiedInteractive() {
    const selectedNodes = this.modifiedinteractiveDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a modified interactive first."
      );
    } else {
      const selectedInteractive: ModifiedInteractiveDetails = selectedData[0];
      ConfirmDialogComponent.showDialog(this.dialog, "Confirm Delete Modified Interactive", "Are you sure you want to delete this modified interactive?").subscribe(result => {
        if (result.ResultType === DialogResultType.Ok) {
          this.permanentDeleteSpecificModifiedInteractive(selectedInteractive.modifiedInteractiveId).then(() => {
            this.loadModifiedInteractives();
          });
        }
      });
    }
  }

  deleteSubscriptionModifiedInteractive() {
    const selectedNodes = this.subscriptionModifedInteractivesDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a modified interactive first."
      );
    } else {
      const selectedInteractive: ModifiedInteractiveDetails = selectedData[0];
      ConfirmDialogComponent.showDialog(this.dialog, "Confirm Delete Modified Interactive", "Are you sure you want to delete this modified interactive?").subscribe(result => {
        if (result.ResultType === DialogResultType.Ok) {
          this.deleteSpecificModifiedInteractive(selectedInteractive.modifiedInteractiveId).then(() => {
            this.loadModifiedInteractives(true);
          });
        }
      });
    }
  }

  permanentDeleteSubscriptionModifiedInteractive() {
    const selectedNodes = this.subscriptionModifedInteractivesDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a modified interactive first."
      );
    } else {
      const selectedInteractive: ModifiedInteractiveDetails = selectedData[0];
      ConfirmDialogComponent.showDialog(this.dialog, "Confirm Delete Modified Interactive", "Are you sure you want to delete this modified interactive?").subscribe(result => {
        if (result.ResultType === DialogResultType.Ok) {
          this.permanentDeleteSpecificModifiedInteractive(selectedInteractive.modifiedInteractiveId).then(() => {
            this.loadModifiedInteractives(true);
          });
        }
      });
    }
  }

  closeInteractiveClicked() {
    this.showPowerBi = false;
  }

  loadPartnerEmbeds() {
    this.loadingPartnerEmbeds = true;
    this.adminPartnerEmbedService
      .partnerEmbedGetPartnerEmbeds()
      .subscribe((result) => {
        this.allPartnerEmbeds = result;
        this.loadingPartnerEmbeds = false;
        this.partnerEmbedDataGrid?.api?.sizeColumnsToFit();
      });
  }

  addPartnerEmbed() {
    let editParams: EditPartnerEmbedData = {
      dialogTitle: "Create Partner Embed",
      isNew: true,
      partnerEmbed: {
        allowRemoteFiltering: false,
        preFiltersApplied: false,
        interactId: 0,
        partnerEmbedKey: '00000000-0000-0000-0000-000000000000',
        partnerEmbedId: 0,
        interactiveName: '',
        enabled: true,
        name: '',
        startPage: '',
        preFilters: [],
        pageRestrictions: [],
        preFilterId: 0
      }
    };

    const dialogRef = this.dialog.open(EditPartnerEmbedDialogComponent, {
      disableClose: true,
      width: "900px",
      height: "600px",
      data: editParams,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (
        dialogResult != null &&
          dialogResult.ResultType !== null &&
          dialogResult.ResultType === DialogResultType.Ok
      ) {
        this.app.pushLoading("Saving Partner Embed...");
        const newEmbed: PartnerEmbedAdminDetails = dialogResult.ResultData.targetEmbed;
        newEmbed.preFilterId = dialogResult.ResultData.preFilterId;
        this.adminPartnerEmbedService.partnerEmbedCreatePartnerEmbed(newEmbed).subscribe(partnerEmbedResult => {
          this.loadPartnerEmbeds();
          this.app.popLoading();;
        });
      }
    });

    return false;
  }

  editSelectedPartnerEmbed() {
    const selectedNodes = this.partnerEmbedDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      const partnerEmbed: PartnerEmbedAdminDetails = selectedData[0];
      let editParams: EditPartnerEmbedData = {
        dialogTitle: "Edit Partner Embed",
        isNew: false,
        partnerEmbed: selectedData[0]
      };

      const dialogRef = this.dialog.open(EditPartnerEmbedDialogComponent, {
        disableClose: true,
        width: "900px",
        height: "600px",
        data: editParams,
      });

      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (
          dialogResult != null &&
          dialogResult.ResultType !== null &&
          dialogResult.ResultType === DialogResultType.Ok
        ) {
          this.app.pushLoading("Saving Partner Embed...");
          const newEmbed: PartnerEmbedAdminDetails = dialogResult.ResultData.targetEmbed;
          const preFilterId: number = dialogResult.ResultData.preFilterId;
          this.adminPartnerEmbedService.partnerEmbedUpdatePartnerEmbed(newEmbed).subscribe(partnerEmbedResult => {
            this.loadPartnerEmbeds();
            this.app.popLoading();
          });
        }
      });
    }

    return false;
  }

  deleteSelectedPartnerEmbed() {
    const selectedNodes = this.partnerEmbedDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete Partner Embed",
        "Are you sure you want to delete this partner embed?"
      ).subscribe((confirmResult) => {
        if (confirmResult.ResultType === DialogResultType.Ok) {
          this.adminPartnerEmbedService
            .partnerEmbedDeletePartnerEmbed(
              selectedData[0].partnerEmbedId
            )
            .subscribe((serviceResult) => {
              this.loadPartnerEmbeds();
            });
        }
      });
    }

    return false;
  }

  copyPartnerEmbedUrl() {
    const selectedNodes = this.partnerEmbedDataGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);

    if (selectedData.length < 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Error",
        "You must select a row first."
      );
    } else {
      this.clipboard.copy(selectedData[0].partnerEmbedUrl);
      MessageDialogComponent.showDialog(
        this.dialog,
        "Success",
        "'" + selectedData[0].partnerEmbedUrl + "' copied to clipboard."
      );

      return false;
    }

    return false;
  }

  resizeColumnsPartnerEmbed() {
    const allColumnIds = [];
    this.partnerEmbedDataGrid.columnApi
      .getAllColumns()
      .forEach(function (column) {
        allColumnIds.push(column.getColId());
      });
    this.partnerEmbedDataGrid.columnApi.autoSizeColumns(
      allColumnIds,
      false
    );

    return false;
  }


  public tosFileToUpload: File = null;
  public ppFileToUpload: File = null;
  public tosUrl: string = '';
  public ppUrl: string = '';

  loadGlobalSettigns() {
    this.settingsService.settingsGetSetting('TOS').subscribe(resultUrl => {
      this.tosUrl = resultUrl;
    });

    this.settingsService.settingsGetSetting('PP').subscribe(resultUrl => {
      this.ppUrl = resultUrl;
    });

    this.settingsService.settingsGetSideNavigation().subscribe(isEnabled => {
      this.enableSideNavigation = isEnabled;
    });
  }

  handleTosFileChange(files: FileList) {
    this.tosFileToUpload = files.item(0);

    this.settingsService.settingsUpdateSetting({
      name: "TOS",
      upload: this.tosFileToUpload
    }).subscribe(() => {
      this.loadGlobalSettigns();
      MessageDialogComponent.showDialog(this.dialog, "Success", "Terms of Service PDF Updated.");
    });
  }

  handlePpFileChange(files: FileList) {
    this.ppFileToUpload = files.item(0);

    this.settingsService.settingsUpdateSetting({
      name: "PP",
      upload: this.ppFileToUpload
    }).subscribe(() => {
      this.loadGlobalSettigns();
      MessageDialogComponent.showDialog(this.dialog, "Success", "Privacy Policy PDF Updated.");
    });
  }

  loadAlerts(): void {
    this.alertsService.alertsGetAllAlertMessages().subscribe(res => {
      this.alertMessages = res;
    });
  }

  createNewAlert(): void {
    this.alertsService.alertsCreateAlertMessage({ isActive: this.newAlertMessage.active, message: this.newAlertMessage.message }).subscribe(res => {
      this.loadAlerts();
      this.newAlertMessage.active = false;
      this.newAlertMessage.message = '';
    });
  }

  saveAlertChanges(msg: AlertModel) {
    this.alertsService.alertsUpdateAlertMessage(msg).subscribe(result => {
      this.loadAlerts();
    });
  }

  deleteAlert(msg: AlertModel) {
    this.alertsService.alertsDeleteAlertMessage(msg).subscribe(result => {
      this.loadAlerts();
    });
  }

  enableSideNavigationChanged($event: Event) {
    setTimeout(() => {
      this.settingsService.settingsSetSideNavigation(this.enableSideNavigation).subscribe();
    }, 1000)
  }
}

interface subscriptionDetailsUser {
  id: number;
  subUserId: number;
  name?: string;
  emailAddress?: string;
  confirmed: boolean;
  userType: UserTypes;
  userTypeName?: string;
  phone?: string;
  userId: number;
  firstName?: string;
  lastName?: string;
  title?: string;
  cityId?: number;
  stateId?: number;
  address1?: string;
  address2?: string;
  zipCode?: string;
  zipCodeExtended?: string;
  userTypeId: number;
  termsAgreement: boolean;
  active: boolean;
  emailConfirmed: boolean;
  govtPositionConfirmed: boolean;
  emailConfirmationGuid?: string;
  createdTimeStamp?: string;
  modifiedTimeStamp?: string;
  company?: string;
  ingressUrl?: string;
  userName?: string;
  invoiceManager?: boolean;
  userManager?: boolean;
}
